﻿/**
 * Created by jehe on 07.02.2019.
 */
/*global define, require, $, window, ol*/

/*jslint browser: true*/
import creator from "./js/elementCreator";
import attribution from "./js/plugins/attributionPlugin";
import layermenu from "./js/plugins/layermenuPlugin";
import baselayerSwitcher from "./js/plugins/baselayerSwitcherPlugin";
import searchPlugin from "./js/plugins/searchPlugin";
import contextPlugin from "./js/plugins/contextMenuPlugin.js";
import topMenuPlugin from "./js/plugins/topMenuToolsPlugin";
import mapWriterPlugin from "./js/plugins/mapWriterPlugin";
import layerspyPlugin from "./js/plugins/layerspyPlugin";
import layerSliderPlugin from "./js/plugins/layerSliderPlugin";
import mapTools from "./js/plugins/mapToolPlugin.js";
import layerImportPlugin from "./js/plugins/layerImportPlugin.js";

("use strict");
var parameters, configs;
var baseUrl = "https://od2.pbe.oslo.kommune.no/";
var extraUrl = "https://od2.pbe.oslo.kommune.no/";
var od1Url = "https://od1.pbe.oslo.kommune.no/";
((parameters = {
  intranett: false,
  wfsTillegg: "&version=1.1.0&service=wfs&request=GetFeature",
  /** Kart-url'er */
  cacheurl: baseUrl + "mapcache/wmts?",
  phpAutocomplete: "https://od2.pbe.oslo.kommune.no/noden/",
  //autocompleteUrl: baseUrl + "php/kartinnsyn/getAutocompleteData.php",
  autocompleteUrl: "https://od2.pbe.oslo.kommune.no/noden/getAutocompleteData",
  searchUrl: baseUrl + "cgi-bin/wms?map=WFS_SOK",
  sakWFSUrl: "/cgi-bin/wms?map=PI4_GEOJSON",
  planinnsynUrl: baseUrl + "cgi-bin/wms?map=PLANINNSYN",
  kartinnsynurl: baseUrl + "cgi-bin/wms?map=KARTINNSYN",
  /** Reguleringsbestemmelser for intranett */
  regbestIntranett: "/regbest/",
  /** Saksinnsyn url-er */
  saksinnsynUrl: "//terra2.pbe.oslo.kommune.no/saksinnsyn4/main.asp",
  saksinnsynDocdetUrl:
    "http://innsyn.pbe.oslo.kommune.no/saksinnsyn/docdet.asp",
  saksinnsynCasedetUrl:
    "http://innsyn.pbe.oslo.kommune.no/saksinnsyn/casedet.asp",
  saksinnsynShowregbestUrl:
    "http://innsyn.pbe.oslo.kommune.no/saksinnsyn/showregbest.asp?",
  geoJsonWFS: baseUrl + "cgi-bin/wms?map=PI4_GEOJSON",
  tableWfs: baseUrl + "cgi-bin/wms?map=EIENDOM_TABELL&tabell=",
  geoJsonOd2WFS: extraUrl + "cgi-bin/wms?map=GEOJSON",
  reguleringUrl: baseUrl + "cgi-bin/wms?map=REGULERING",
  mapcacheurl: baseUrl + "mapcache/wmts?",
  omradeUrl: baseUrl + "cgi-bin/wms?map=REGTILLEGG",
  ki_forgrunnurl: baseUrl + "cgi-bin/wms?map=FORGRUNN",
  kommuneplanurl: baseUrl + "cgi-bin/wms?map=KOMMUNEPLAN",
  kdpUrl: baseUrl + "cgi-bin/wms?map=KDP",
  gullisteUrl: baseUrl + "cgi-bin/wms?map=GULLISTE",
  forurensetgrunnurl: baseUrl + "cgi-bin/wms?map=FORURENSET",
  funnpotensialeUrl: baseUrl + "cgi-bin/wms?map=FUNNPOTENSIALE",
  vannBekkerEleverurl: baseUrl + "cgi-bin/wms?map=VANN_NY",
  fjernvarmeurl: baseUrl + "cgi-bin/wms?map=FJERNVARME",
  risikourl: baseUrl + "cgi-bin/wms?map=RISIKO",
  vegtypeurl: baseUrl + "cgi-bin/wms?map=VEGKATEGORI",
  fartsgrenserurl: baseUrl + "cgi-bin/wms?map=FARTSGRENSER",
  naturmangfoldurl: baseUrl + "cgi-bin/wms?map=NATURMANGFOLD",
  flyfotoUrl: baseUrl + "cgi-bin/wms?map=FLYFOTO",
  flyfotoHist: od1Url + "cgi-bin/wms?map=FLY_HIST",
  flyfotoTextUrl: baseUrl + "cgi-bin/wms?map=TEKST_FLYFOTO",
  planmetaWSUrl:
    "https://od2.pbe.oslo.kommune.no/noden/Planmetadata/planmetadata?",
  vedtakWSUrl: extraUrl + "tomcat8/Vedtaksdok/vedtaksdok?",
  trafikkmengdeurl: baseUrl + "cgi-bin/wms?map=AADT",
  trafikkmengdeWMSurl: baseUrl + "cgi-bin/wms?MAP=AADT",
  blagronnurl: baseUrl + "cgi-bin/wms?map=BLAGRONNFAKTOR",
  reklameurl: baseUrl + "cgi-bin/wms?map=SKILTREKLAME",
  paagaaendeurl: baseUrl + "cgi-bin/wms?map=PAAGAAENDE",
  ploturl: baseUrl + "xkart/plott/?",
  bakgrunnGraaUrl: baseUrl + "cgi-bin/wms?map=BAKGRUNN",
  planerUrl: baseUrl + "cgi-bin/wms?map=PLANER",
  sidinmeningUrl: "http://innsyn.pbe.oslo.kommune.no/sidinmening/main.asp",
  friluftUrl: baseUrl + "cgi-bin/wms?map=FRILUFT",
  avrenningURL: baseUrl + "cgi-bin/wms?map=AVRENNING",
  grunnforholdURL: baseUrl + "/cgi-bin/wms?map=GRUNNFORHOLD",
  kartlagtURL: baseUrl + "cgi-bin/wms?map=KARTLAGTSKRED",
  flomURL: baseUrl + "cgi-bin/wms?map=FLOM",
  torshovURL: baseUrl + "cgi-bin/wms?map=TORSHOV",
}),
  (configs = {
    minZoom: 11,
    mapTools: [
      {
        id: "measure-area-small",
        className: "area-btn measure-btn",
        toolTip: "Mål areal",
        buttonText: "Mål areal",
        iconType: "text",
        icon: "m²",
        onclick: "measureAreaClick",
        register: function (registerFunction, callback) {
          mapTools.registerAreaMeasurePlugin(registerFunction, callback);
        },
        toolHelp: {
          header: "Slik måler du",
          id: "measure-area-small-tool-help",
          steps: [
            "Klikk i kartet for plassere punktene du skal måle mellom.",
            "Dobbelklikk når du plasserer siste punkt for å fullføre en måling.",
            'Slett målingene når du er ferdig. Bruk knappen "Fjern markeringer i kartet" <i class = "glyphicon glyphicon-erase" aria-label="Fjern markeringer i kartet"></i>',
          ],
        },
      },
      {
        id: "measure-length-small",
        className: "length-btn measure-btn",
        toolTip: "Mål avstand",
        buttonText: "Mål avstand",
        iconType: "icon",
        icon: "icon-measure",
        onclick: "measureLengthClick",
        register: function (registerFunction, callback) {
          mapTools.registerLengthMeasurePlugin(registerFunction, callback);
        },
        toolHelp: {
          header: "Slik måler du",
          id: "measure-length-small-tool-help",
          steps: [
            "Klikk i kartet for plassere punktene du skal måle mellom.",
            "Dobbelklikk når du plasserer siste punkt for å fullføre en måling.",
            'Slett målingene når du er ferdig. Bruk knappen "Fjern markeringer i kartet" <i class = "glyphicon glyphicon-erase" aria-label="Fjern markeringer i kartet"></i>',
          ],
        },
      },
      {
        id: "make-sketch-small",
        className: "sketch-btn",
        toolTip: "Lag tegninger",
        buttonText: "Lag tegninger",
        iconType: "icon",
        icon: "fa fa-pencil",
        onclick: "drawClick",
        register: function (registerFunction, callback) {
          mapTools.registerDrawPlugin(registerFunction, callback);
        },
        toolHelp: {
          header: "Slik tegner du",
          id: "make-sketch-small-tool-help",
          steps: [
            "Klikk i kartet for plassere punktene i tegningen.",
            "Dobbelklikk når du plasserer siste punkt for å fullføre en tegning.",
            'Slett tegningene når du er ferdig. Bruk knappen "Fjern markeringer i kartet" <i class = "glyphicon glyphicon-erase" aria-label="Fjern markeringer i kartet"></i>',
          ],
        },
      },
      {
        id: "zoom-full-small",
        className: "map-eraser-btn",
        toolTip: "Zoom til hele Oslo",
        buttonText: "Zoom helt ut",
        iconType: "icon",
        icon: "glyphicon glyphicon-globe",
        onclick: "zoomFullClick",
      },
      {
        id: "map-eraser-small",
        className: "map-eraser-btn",
        toolTip: "Fjern markeringer av eiendommer og planer i kartet",
        buttonText: "Fjern markeringer",
        iconType: "icon",
        icon: "glyphicon glyphicon-erase",
        onclick: "eraserClick",
      },
      {
        id: "layer-import",
        className: "import-btn",
        toolTip: "Dra og slipp for å importere",
        buttonText: "Import",
        iconType: "icon",
        icon: "fa fa-upload",
        onclick: "importClick",
        register: function (registerFunction, callback) {
          layerImportPlugin.registerPluginFunction(registerFunction, callback);
        },
      },
      {
        id: "text-on-map",
        className: "write-btn",
        toolTip: "Skriv på kartet",
        buttonText: "Skriv på kartet",
        iconType: "icon",
        icon: "fa fa-font",
        onclick: "mapWriterClick",
        register: function (registerFunction, callback) {
          mapWriterPlugin.registerPluginFunction(registerFunction, callback);
        },
      },
      {
        id: "layer-spy",
        className: "point-search-btn",
        toolTip: "Se på underliggende kartlag med kikkehullet",
        buttonText: "Kikkehull",
        iconType: "icon",
        icon: "icon-Kikkehull",
        touchSensitive: true,
        onclick: "spyClick",
        parameters: "flyfoto",
        register: function (registerFunction, callback) {
          layerspyPlugin.registerPluginFunction(registerFunction, callback);
        },
        toolHelp: {
          header: "Kikkehull",
          id: "layer-spy-tool-help",
          steps: [
            "Bruk musepekeren til å se på flyfoto under kartet.",
            "Bruk piltast opp eller ned for å gjøre kikkehullet større eller mindre",
          ],
        },
      },
      {
        id: "layer-slider",
        className: "slider-btn",
        toolTip:
          "Bruk slideren til å skjule deler av kartlaget eller gjøre det mer gjennomsiktig.",
        buttonText: "Slide",
        iconType: "icon",
        icon: "fa fa-sliders",
        onclick: "mapSliderClick",
        register: function (registerFunction, callback) {
          layerSliderPlugin.registerPluginFunction(registerFunction, callback);
        },
      },
    ],
    topMenu: [
      {
        type: "button",
        id: "planinnsyn-hjelp",
        toolTip: "Åpner hjelpemeny.",
        icon: true,
        iconClass: "icon-Menu",
        innerHTML: "<div class='textHider'>Om tjenesten<div>",
        onclick: function () {
          $("#share-page").hide(250);
          $("#help-page").toggle(250);
          $(".show-collapsible").removeClass("show-collapsible");
          $("#planinnsyn-hjelp").toggleClass("drop-down-row-active");
          $("#planinnsyn-hjelp")
            .find("i")
            .toggleClass("icon-Menu")
            .toggleClass("icon-Close");
        },
        /* OM TJENESTEN */
        contentPage: "helpMenu",
        content: [
          {
            type: "article",
            text: [
              {
                paragraph:
                  "Plan- og bygningsetaten ønsker å levere data av høy kvalitet, men kan ikke garantere at innholdet i tjenesten er uten feil og mangler.",
              },
              {
                paragraph:
                  "Et reguleringsplankart er en sammenstilling av alle planforslag og gjeldende reguleringsplaner, og sammenstillingen er ikke juridisk bindende.",
              },
              {
                h4: "Kart og eiendomsinformasjon er beskyttet etter åndsverkloven.",
              },
            ],
          },
          {
            type: "helpTopic",
            header: "Tips",
            id: "tips",
            ariaLabel: "vis/skjul tips",
            text: [
              {
                h4: "Klikk i kartet for å se detaljert informasjon om eiendommen",
              },
              {
                paragraph:
                  "Ved å klikke i kartet finner du blant annet gårds- og bruksnummer og planer som gjelder for eiendommen eller punktet du klikket i.",
              },
              { h4: "Du kan finne bestemmelsene til en plan i Planinnsyn" },
              {
                paragraph:
                  "Klikk i kartet, velg «Reguleringsplaner» og klikk på «Reguleringsbestemmelser».",
              },
              { h4: "<Du kan finne data om planene i Planinnsyn" },
              {
                paragraph:
                  "Klikk i kartet, velg «Kommunedelplan», «Områderegulering» eller «Reguleringsplaner» og klikk på plannummeret. For kommuneplan, må du velge «Mer info om kommuneplanen».",
              },
              { h4: "Finn tegnforklaringer til kartet" },
              {
                paragraph:
                  "De fleste kart har tegnforklaringer under «Mer info» -knappen i menyen til venstre. Noen kartlag har også tegnforklaring i menyen som dukker opp når du klikker i kartet eller søker på en adresse eller eiendom.",
              },
            ],
            addAdditional: function (article) {
              if (configs.modes && Object.keys(configs.modes).length > 0) {
                article.appendChild(
                  creator.createParagraph({
                    text: "<strong>Du kan bruke mode i URL for å starte planinnsyn med enkelte kartlag slått på</strong>",
                  }),
                );
                article.appendChild(
                  creator.createParagraph({
                    text: "Ved å bruke mode='modus' i urlen kan du starte planinnsyn med gitte kartlag skrudd på.",
                  }),
                );
                article.appendChild(
                  creator.createParagraph({
                    text: "Eks: https://od2.pbe.oslo.kommune.no/kart/?mode=gulliste",
                  }),
                );
                article.appendChild(
                  creator.createParagraph({ text: "Gyldige moduser er:" }),
                );
                var baseHref = window.location.href.split("#")[0].split("?")[0];
                article.appendChild(
                  creator.createUl({
                    listItems: configs.modes
                      .filter((mode) => !mode.handler)
                      .map(
                        (mode) =>
                          "<a href=" +
                          baseHref +
                          "?mode=" +
                          mode.mode +
                          ">" +
                          mode.mode +
                          "</a>",
                      ),
                  }),
                );
              }
            },
          },
          {
            type: "helpTopic",
            header: "Informasjon i kartet",
            id: "kartinfo",
            ariaLabel: "vis/skjul informasjon om hva som finnes i kartet",
            text: [
              { h4: "Klikk i kartet" },
              {
                paragraph:
                  "Ved å klikke i kartet finner du blant annet gårds- og bruksnummer og planer som gjelder for eiendommen eller punktet du klikket i.",
              },
              {
                paragraph:
                  "Du kan få informasjon om utvalgte kartobjekter ved å klikke i kartet. Når du klikker et sted i kartet vil du få opp en meny på høyre side med informasjon om hvilke planer som gjelder for eiendommen du har klikket på, samt en rekke temaer. Dersom du har fått treff for et tema vil antall treff vises i parentes bak temaet. Dersom du ikke har fått treff vil temaet være grået ut. Det er to faner i menyen, én for eiendommen og én for punktet du klikket på.",
              },
              {
                paragraph:
                  "Hvis du klikker i menyen på høyre side får du mer informasjon om treffene, og du får lenker til mer informasjon.",
              },
              {
                paragraph:
                  "For kommuneplan, kommunedelplan, områderegulering, reguleringsplaner og Gul liste kan du sette markøren på et formål og få det markert i kartet. Dette vil ikke virke for berøringsskjermer.",
              },
              {
                paragraph:
                  "Under <span>Plankunngjøringer</span> kan du se planforslag som berører eiendommen der du klikket og som enten er til offentlig ettersyn, skal vedtas eller som er i ferd med å starte opp. Klikk på tittelen for å komme til en side der du kan si din mening.",
              },
              {
                paragraph:
                  "Under <span>Byggesaker</span> får du informasjon byggesaker som er registrert på eiendommen der du klikket. Det er kun de tre ferskeste sakene som vises. For å se alle, klikk på «Vis alle byggesaker».",
              },
              {
                paragraph:
                  "Under <span>Plansaker</span> får du informasjon plansaker som er registrert på eiendommen der du klikket. Det er kun de tre ferskeste sakene som vises. For å se alle, klikk på «Vis alle plansaker».",
              },
              {
                paragraph:
                  "Under <span>Gul liste</span> kan du se om det er bygninger eller områder som er oppført på Byantikvarens gule liste der du klikket. Klikk på de enkelte treffene for å se mer om hva som er registrert og for lenke videre til Kulturminnesøk.",
              },
              {
                paragraph:
                  'Nederst i menyen finner du dyplenker til produktene reguleringskart, digitale kartdata og meglerpakke i Bestillingstjenesten. Du finner også en lenke til siden "Skal du bygge, rive eller endre?" på Oslo kommunes nettsider.',
              },
              {
                paragraph:
                  "Nederst i menyen finner du dyplenker til tjeneste for å lage reguleringsplott og til tjenesten Hva gjelder for eiendommen.",
              },
            ],
          },
          {
            type: "helpTopic",
            header: "Reguleringsbestemmelser",
            id: "regbest",
            ariaLabel: "vis/skjul informasjon om reguleringsbestemmelser",
            text: [
              { h4: "Hvordan finne reguleringsbestemmelser?" },
              {
                paragraph:
                  "For å finne reguleringsbestemmelsen til en plan klikker du i kartet og velger Reguleringsplaner. Klikk på «Reguleringsbestemmelser». Du kan også søke på plannummeret for å få opp planen.",
              },
            ],
          },
          {
            type: "helpTopic",
            header: "Søk",
            id: "sok",
            ariaLabel: "vis/skjul informasjon om hvordan du søker",
            text: [
              { h4: "Hvordan søke?" },
              {
                paragraph:
                  "I søkefeltet kan du søke på adresser, stedsnavn, gårds- og bruksnummer, koordinat, plannavn eller saksnummer.",
              },
              {
                paragraph:
                  "<strong>Adresse:</strong> For å søke på en adresse, start med å skrive inn gatenavn i søkefeltet. Etter at du har skrevet minst tre bokstaver vil du få opp forslag på gatenavn eller stedsnavn som passer med det du har skrevet inn. Velg fra listen og du får opp et vindu med adresser for den valgte gaten.",
              },
              {
                paragraph:
                  "<strong>Stedsnavn:</strong> For å søke på et stedsnavn, start med å skrive i søkefeltet. Etter at du har skrevet minst tre bokstaver vil du få opp forslag på gatenavn eller stedsnavn som passer med det du har skrevet inn. På høyre side i listen ser du om forslaget er en gate eller et stedsnavn. Velg fra listen for å gå til stedet du ønsker.",
              },
              {
                paragraph:
                  "<strong>Eiendom:</strong> For å søke på en eiendom, skriv på formen gnr/bnr.<br>Eksempel: <span>101/1</span>.",
              },
              {
                paragraph:
                  '<strong>Koordinat:</strong> For å søke på koordinat skriv inn nord-koordinat og øst-koordinat adskilt med tegnet "|" (tasten til venstre for "1"). Søket fungerer også om du snur om på rekkefølgen på koordinatene.<br>Eksempel: <em>6643409|598546</em>',
              },
              {
                paragraph:
                  "<strong>Plannavn:</strong> For å søke på en reguleringsplan skriver du inn plannavnet.<br>Eksempel: <span>S-3478</span>. Etter at du har skrevet inn minst tre tegn vil du få opp forslag på planer som passer med det du har skrevet inn. Velg plan fra listen.",
              },
              {
                paragraph:
                  "<strong>Saksnummer:</strong> For å søke på en sak (byggesak/plansak) skriv inn saksnummeret i søkefeltet.<br>Eksempel: <em>201600477</em>.",
              },
            ],
          },
          {
            type: "helpTopic",
            header: "Løsningen og kartdataene",
            id: "about",
            ariaLabel: "vis/skjul informasjon om løsningen og kartdataene",
            text: [
              { h4: "Om løsningen" },
              {
                paragraph:
                  "Løsningen utvikles og driftes av Plan- og bygningsetaten.",
              },
              {
                paragraph:
                  "Det kan forekomme feil i symbolisering av reguleringskartet. Feilene vil bli rettet så fort vi blir oppmerksomme på dem.",
              },
              { h4: "Om kartdataene" },
              {
                paragraph:
                  "<span>Planer:</span> De øverste kartlagene i menyen til venstre er plankart. Kommuneplan, Kommunedelplaner og Reguleringsplaner kan ekspanderes ved hjelp av pilen til høyre for å filtrere ut det du ikke ønsker å se på. Områderegulering og Reguleringsplaner oppdateres hver natt. De andre oppdateres når det skjer endringer.",
              },
              {
                paragraph:
                  "<span>Pågående saker: </span>Disse kartlagene viser ulike planer som ikke er vedtatt og byggesaker som er pågående.",
              },
              {
                paragraph:
                  "<span>Temakart:</span> Under temakart finner du kart som er laget for å belyse et bestemt tema innenfor et gitt geografisk område. Det tematiske kartet viser som regel bare informasjon om ett eller et fåtall emner. Du finner tegnforklaring og informasjon om hvert kartlag ved å klikke på «Mer info» i menyen.",
              },
              {
                paragraph:
                  "<span>Historiske flyfoto:</span> Du finner flyfoto fra 1937, 1947, 1971, 1984 og 1997. Velg «ingen» for å slå av historiske flyfoto.",
              },
              { paragraph: "<span>Detaljer:</span>" },
              {
                ul: [
                  "Kartlaget «Bygninger, veier, koter m.m.» kalles ofte grunnkart og viser situasjonen slik den er i dag. Kartet er konstruert hovedsakelig fra flyfoto som tas om våren hvert år. Dette kartet oppdateres en gang i uken.",
                  "«Gatenavn, adresser m.m.» viser stedsnavn, gatenavn, adressenummer med mer. Kartlaget oppdateres en gang i uken.",
                  "«Eiendomsgrenser» viser eiendomsgrenser, seksjonsgrenser og gårds- og bruksnummer. Gårds- og bruksnummer vises bare når du har zoomet inn på en eiendom. Eiendomskartet oppdateres hver natt.",
                  "«Bydelsgrenser» viser bydelsgrenser og bydelsnavn. Oppdateres ved behov.",
                ],
              },
              {
                paragraph:
                  "<span>Flyfoto/Bakgrunnskart: </span>Flyfoto blir fornyet hvert år. Bakgrunnskart er et forenklet situasjonskart som i hovedsak viser bygninger, veier og vann.",
              },
              { h4: "<strong>Kjøp av kartdata</strong>" },
              {
                paragraph:
                  "Kartdata kan kjøpes via Bestillingstjenesten, Infoland eller vårt Kundesenter. Når du klikker i kartet slik at du før opp informasjonsmenyen til høyre har du mulighet til å bruke hurtiglenker for å bestille byggesakspakke eller eiendomsmeglerpakke. Hurtiglenken tar med seg gårds- og bruksnummeret til eiendommen du klikket på.",
              },
            ],
          },
        ],
      },
      {
        type: "button",
        id: "planinnsyn-del",
        toolTip: "Del siden, eller lag bokmerke/snarvei.",
        icon: true,
        iconClass: "icon-Del",
        innerHTML: "Del",
        onclick: "shareClick",
        contentPage: "sharePage",
      },
    ],
    baseLayers: [
      {
        olType: "group",
        layerId: "baselayers",
        layers: [
          {
            olType: "wmts",
            title: "Bakgrunnskart",
            layerId: "bakgrunn",
            url: parameters.mapcacheurl,
            layerName: "bakgrunn_graa",
            visible: false,
            dependent: "text1",
            altSource: {
              url: parameters.bakgrunnGraaUrl,
              layerName: "bakgrunn_graa",
            },
          },
          {
            olType: "wmts",
            layerId: "flyfoto",
            title: "Flyfoto",
            url: parameters.mapcacheurl + "map=FLYFOTO",
            layerName: "flyfoto",
            dependent: "text2",
            altSource: {
              url: parameters.flyfotoUrl,
              layerName: "nyeste_flyfoto_bg_hvit",
              epsg: "EPSG:32632",
            },
            visible: false,
          },
          {
            olType: "image",
            title: "Gatenavn, adresser, m.m (flyfoto)",
            layerId: "text2",
            url: parameters.flyfotoTextUrl,
            layerName: "forgrunn_tekst",
            zIndex: 100,
            visible: false,
          },
          {
            olType: "image",
            title: "Regulert over bakken - tekst",
            layerId: "regv2tekst",
            url: parameters.reguleringUrl,
            layerName: "Bakkenivaa_vannoverflate_2_paaskrift",
            zIndex: 100,
            displayInLayerMenu: false,
            visible: true,
          },
          {
            olType: "image",
            title: "TrafikkmengdeWfs",
            layerId: "AADT_fastskala",
            url: parameters.trafikkmengdeurl,
            layerName: "AADT_fastskala",
            zIndex: 100,
            displayInLayerMenu: false,
            visible: false,
          },
          {
            olType: "image",
            title: "Tiltaksflater",
            layerId: "tiltaksflate",
            url: parameters.ki_forgrunnurl,
            zIndex: 200,
            layerName: "Tiltaksflate",
            displayInLayerMenu: false,
            noToggle: true,
            visible: true,
          },
        ],
      },
    ],
    layermenuLayers: [
      {
        olType: "group",
        layerId: "plan_og_byggesak",
        title: "Planer",
        collapsible: true,
        groupCheckbox: false,
        layers: [
          {
            olType: "group",
            title: "Kommuneplan",
            layerId: "kp",
            layerInfo: true,
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "group",
                title: "Plankart 1-2 Arealbruk",
                layerId: "kp_pk1_2",
                layerInfo: true,
                groupCheckbox: true,
                visible: false,
                layers: [
                  {
                    olType: "image",
                    layerInfo: true,
                    title: "Arealformål",
                    layerId: "kp_pk1-2_arealformaal",
                    url: parameters.kommuneplanurl,
                    layerName: "arealformaal",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: true,
                    title: "Hensynssoner",
                    layerId: "kp_pk1-2_hensynssoner",
                    url: parameters.kommuneplanurl,
                    layerName: "hoved_hensyn",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: true,
                    title: "Juridiske linjer og symboler",
                    layerId: "kp_pk1-2_juridisk",
                    url: parameters.kommuneplanurl,
                    layerName: "hoved_juridisk",
                    visible: false,
                  },
                  {
                    olType: "image",
                    layerInfo: true,
                    title: "Ikke juridiske objekter",
                    layerId: "kp_pk1-2_ikke_juridisk",
                    url: parameters.kommuneplanurl,
                    layerName: "hoved_ikke_juridisk",
                    visible: false,
                  },
                ],
              },
              {
                olType: "image",
                layerInfo: true,
                title: "Plankart 2-2 Hensynssoner",
                layerId: "kp_pk2_2",
                url: parameters.kommuneplanurl,
                layerName: "hensyn_hensyn",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                layerInfo: true,
                title: "T1 Støy",
                layerId: "kp_tema_juridisk_stoy",
                url: parameters.kommuneplanurl,
                layerName: "tema_t1",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                layerInfo: true,
                title: "T2 Luftforurensing (nitrogendioksid)",
                layerId: "kp_tema_ikke_juridisk_luftforurensing_t2",
                url: parameters.kommuneplanurl,
                layerName: "t2_luftforurensing,markagrense,planens_avgrensning",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                layerInfo: true,
                title: "T3 Luftforurensing (svevestøv)",
                layerId: "kp_tema_ikke_juridisk_luftforurensing_t3",
                url: parameters.kommuneplanurl,
                layerName: "t3_luftforurensing,markagrense,planens_avgrensning",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                layerInfo: true,
                title: "T4 Naturmiljø",
                layerId: "kp_tema_juridisk_naturmiljo",
                url: parameters.kommuneplanurl,
                layerName: "tema_t4,markagrense,planens_avgrensning",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                layerInfo: true,
                title: "T5 Kulturminnevern",
                layerId: "kp_tema_ikke_juridisk_kulturminnevern",
                url: parameters.kommuneplanurl,
                //layerName: "markagrense,planens_avgrensning,t4_marka_temakart",
                //layerName: "t5_Verneklasse2_Tema",
                layerName:
                  "t5_baandlegging_andre_lover,t5_avklart_uavklart_indre_by,t5_avklart_uavklart_ytre_by,t5_Verneklasse2_Tema,t5_baandlegging_lov_om_kulturminner,t5_hensynssone_c,t5_nasjonal_verneverdi,t5_indre_by,t5_freda_bygninger",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                layerInfo: true,
                title: "T6 Storulykke",
                layerId: "kp_tema_juridisk_storulykke",
                url: parameters.kommuneplanurl,
                layerName:
                  "t6_brann_eksplosjonsfare,markagrense,planens_avgrensning,t4_marka_temakart",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                layerInfo: true,
                title: "T7 Blågrønn struktur",
                layerId: "kp_tema_juridisk_blaagronn_struktur",
                url: parameters.kommuneplanurl,
                layerName: "tema_t7,markagrense,planens_avgrensning",
                dontCascade: true,
                visible: false,
              },
            ],
          },
          {
            olType: "image",
            title: "Markagrense",
            layerId: "markagr",
            url: parameters.planinnsynUrl,
            layerName: "Marka_PI4",
            layerInfo: true,
            visible: false,
          },
          {
            olType: "group",
            title: "Kommunedelplaner",
            layerId: "kdp",
            layerInfo: true,
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "image",
                title: "Skøyen (Kdp 1 og 9)",
                layerId: "kdp1_9",
                url: parameters.kdpUrl,
                layerName: "KDP 1_9",
                visible: false,
              },
              {
                olType: "image",
                title: "Akerselva miljøpark (Kdp 4)",
                layerId: "kdp4",
                url: parameters.kdpUrl,
                layerName: "KDP4",
                visible: false,
              },
              {
                olType: "image",
                title: "Næringskorridor syd (Kdp 7)",
                layerId: "kdp7",
                url: parameters.kdpUrl,
                layerName: "KDP7",
                visible: false,
              },
              {
                olType: "image",
                title: "Lofsrud - Mortensrud (Kdp 12)",
                layerId: "kdp12",
                url: parameters.kdpUrl,
                layerName: "KDP12",
                visible: false,
              },
              {
                olType: "image",
                title: "Økernområdet (Kdp 15)",
                layerId: "kdp15",
                url: parameters.kdpUrl,
                layerName: "KDP15",
                visible: false,
              },
              {
                olType: "image",
                title: "Torg og møteplasser (Kdp 17)",
                layerId: "kdp17",
                url: parameters.kdpUrl,
                layerName: "KDP17",
                visible: false,
              },
              {
                olType: "image",
                title: "Alna miljøpark (Kdp 18)",
                layerId: "kdp18",
                url: parameters.kdpUrl,
                layerName: "KDP18",
                visible: false,
              },
              {
                olType: "image",
                title: "Lysakervassdraget (Kdp 19)",
                layerId: "kdp19",
                url: parameters.kdpUrl,
                layerName: "KDP19",
                visible: false,
              },
            ],
          },
          {
            olType: "vector",
            title: "Områderegulering",
            layerId: "omreg",
            url: parameters.omradeUrl + parameters.wfsTillegg,
            typeName: "Omraadeplan",
            featureInfo: true,
            layerInfo: true,
            fillColor: "rgba(219, 194, 95, 0.8)",
            fillColorAlt: "rgba(205, 128, 153, 0.5)",
            layerName: "Omraadeplan",
            attribute: "STATUS",
            visible: false,
          },
          {
            olType: "group",
            title: "Reguleringsplaner",
            layerId: "reg",
            layerInfo: true,
            groupCheckbox: true,
            visible: true,
            default: true,
            layers: [
              {
                olType: "image",
                title: "Regulert på havbunnen",
                layerId: "regv4",
                url: parameters.reguleringUrl,
                layerName: "Paa_bunnen_4,RPPAASKRIFT_4",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                title: "Regulert under bakken",
                layerId: "regv1",
                url: parameters.reguleringUrl,
                layerName: "Under_bakkenivaa_tunnel_1,RPPAASKRIFT_1",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "image",
                title: "Regulert i vannsøylen",
                layerId: "regv5",
                url: parameters.reguleringUrl,
                layerName: "I_vannsoylen_5,RPPAASKRIFT_5",
                dontCascade: true,
                visible: false,
              },
              {
                olType: "wmts",
                title: "Regulert på bakkenivå",
                layerId: "regv2",
                dependent: "regv2tekst",
                exclude: "bakgrunn",
                url: parameters.mapcacheurl,
                layerName: "regulering_v2",
                altSource: {
                  url: parameters.reguleringUrl,
                  layerName: "Bakkenivaa_vannoverflate_2",
                },
                dontCascade: false,
                visible: true,
                default: true,
              },
              {
                olType: "image",
                title: "Regulert over bakken",
                layerId: "regv3",
                url: parameters.reguleringUrl,
                layerName: "Over_bakkenivaa_bru_3,RPPAASKRIFT_3",
                dontCascade: true,
                visible: false,
              },
            ],
          },
          {
            olType: "image",
            title: "Skilt- og reklameplan",
            layerId: "reklameomrader",
            layerName:
              "Planomrade,XS_Omrader,S_Omrader,M_Omrader,L_Omrader,L_Omrade_Riksvei,L_Omrade_Stroksgate,M_Omrade_Hovedgate,L_Omrade_Symbol",
            url: parameters.reklameurl,
            layerInfo: true,
            visible: false,
            opacity: 2,
          },
          {
            olType: "image",
            title: "Torshovkvartalene",
            layerId: "torshovkvartalene",
            layerName: "Torshov",
            url: parameters.torshovURL,
            layerInfo: true,
            visible: false,
            opacity: 2,
          },
          {
            olType: "vector",
            title: "Planprogram",
            layerId: "planprogram",
            url: parameters.geoJsonWFS + parameters.wfsTillegg,
            typeName: "planprogram_vedtatt",
            layerInfo: true,
            featureInfo: true,
            fillColor: "rgba(0, 150, 150, 0.8)",
            fillColorAlt: "rgba(0, 255, 255, 0)",
            attribute: "STATUS",
            visible: false,
          },
          {
            olType: "vector",
            title: "Veiledende plan for offentlige rom (VPOR)",
            layerId: "vpor",
            url: parameters.geoJsonWFS + parameters.wfsTillegg,
            typeName: "vpor_vedtatt",
            layerInfo: true,
            featureInfo: true,
            fillColor: "rgba(225, 128, 153, 0.8)",
            fillColorAlt: "rgba(205, 128, 153, 0)",
            attribute: "STATUS",
            visible: false,
          },
          {
            olType: "vector",
            title: "Tiltaksliste for offentlige rom (TOR)",
            layerId: "tor",
            url: parameters.geoJsonWFS + parameters.wfsTillegg,
            typeName: "tor",
            layerInfo: true,
            featureInfo: true,
            fillColor: "rgba(141, 80, 177, 0.8)",
            fillColorAlt: "rgba(141, 80, 177, 0)",
            attribute: "STATUS",
            visible: false,
          },
          {
            olType: "group",
            title: "Strategisk plan for Hovinbyen",
            layerId: "hovinbyen",
            layerInfo: true,
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "vector",
                title: "Planområdet",
                layerId: "hovinbyenF",
                url: parameters.planerUrl + parameters.wfsTillegg,
                typeName: "hovinbyen_flate",
                layerInfo: false,
                featureInfo: true,
                fillColor: "rgba(204, 102, 0, 0.6)",
                fillColorAlt: "rgba(205, 128, 153, 0)",
                drawType: "stipletfyll",
                attribute: "STATUS",
                featureAttribute: "arbeid",
                visible: false,
              },
              {
                olType: "vector",
                title: "Aksene og den grønne ringen",
                layerId: "hovinbyen_a",
                url: parameters.planerUrl + parameters.wfsTillegg,
                typeName: "hovinbyen_aksene",
                fillColor: "rgba(255, 255, 255, 1)",
                drawType: "stroke",
                layerInfo: false,
                featureInfo: true,
                visible: false,
                dependent: "hovinbyen_r",
              },
              {
                olType: "image",
                layerId: "hovinbyen_r",
                url: parameters.planerUrl,
                layerName: "hovinbyen_aksene",
                layerInfo: false,
                featureInfo: true,
                visible: false,
                displayInLayerMenu: false,
              },
            ],
          },
        ],
      },
      {
        olType: "group",
        layerId: "saksinnsyn-kart",
        title: "Pågående saker",
        collapsible: true,
        groupCheckbox: false,
        layers: [
          {
            olType: "group",
            title: "Plansaker (pågående)",
            layerId: "plansak",
            collapsible: true,
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "vector",
                title: "Områderegulering",
                layerId: "omraaderegulering",
                layerName: "omraaderegulering",
                url:
                  parameters.paagaaendeurl +
                  "&version=1.1.0&service=wfs&request=GetFeature",
                typeName: "omraaderegulering",
                layerInfo: true,
                featureInfo: true,
                featureInfoLayout: {},
                featureInfoValues: {},
                fillColor: "rgba(219, 194, 95, 0.8)",
                visible: false,
              },
              {
                olType: "vector",
                title: "Detaljregulering",
                layerId: "detaljregulering",
                layerName: "detaljregulering",
                url: parameters.paagaaendeurl + parameters.wfsTillegg,
                filter:
                  "&Filter=<Filter><PropertyIsNotEqualTo><PropertyName>S</PropertyName><Literal>202102096</Literal></PropertyIsNotEqualTo></Filter>",
                typeName: "detaljregulering",
                layerInfo: true,
                featureInfo: true,
                fillColor: "rgba(255, 0, 255, 0.8)",
                visible: false,
              },
              {
                olType: "vector",
                title: "Småhusplanen (revisjon av S-4220)",
                layerId: "smahusplanen",
                url: parameters.paagaaendeurl + parameters.wfsTillegg,
                filter:
                  "&Filter=<Filter><PropertyIsEqualTo><PropertyName>S</PropertyName><Literal>202102096</Literal></PropertyIsEqualTo></Filter>",
                zIndex: 200,
                layerName: "detaljregulering",
                typeName: "detaljregulering",
                fillColorAlt: "rgba(199, 246, 201, 0.6)",
                fillColor: "rgba(199, 246, 201, 0.6)",
                featureInfo: true,
                visible: false,
                groupCheckbox: true,
              },
              {
                olType: "vector",
                title: "Planprogram",
                layerId: "planprogrampaagaaende",
                url: parameters.paagaaendeurl + parameters.wfsTillegg,
                typeName: "planprogram",
                layerInfo: true,
                featureInfo: true,
                fillColor: "rgba(0, 255, 255, 0.8)",
                fillColorAlt: "rgba(0, 255, 255, 0.5)",
                attribute: "STATUS",
                visible: false,
              },
              {
                olType: "vector",
                title: "Veiledende plan for offentlige rom (VPOR)",
                layerId: "vporpaagaaende",
                url: parameters.paagaaendeurl + parameters.wfsTillegg,
                typeName: "vpor",
                layerInfo: true,
                featureInfo: true,
                fillColor: "rgba(205, 128, 153, 0.8)",
                fillColorAlt: "rgba(205, 128, 153, 0.5)",
                attribute: "STATUS",
                visible: false,
              },
            ],
          },
          {
            olType: "vector",
            title: "Plankunngjøringer",
            layerId: "kunngjoringer",
            url: parameters.geoJsonWFS + parameters.wfsTillegg,
            typeName: "poly_kunngj",
            layerInfo: true,
            featureInfo: true,
            fillColor: {
              comparator: "B1",
              "Oppstart av plan": "rgba(255, 130, 116, 0.8)",
              "Offentlig ettersyn": "rgba(67, 248, 182, 0.8)",
              "Vedtatt plan": "rgba(249, 198, 107, 0.8)",
            },
            visible: false,
          },
          {
            olType: "vector",
            title: "Midlertidig forbud mot tiltak",
            layerId: "MFT",
            url: parameters.paagaaendeurl + parameters.wfsTillegg,
            typeName: "MFT",
            layerInfo: false,
            featureInfo: true,
            fillColor: "rgba(255, 0, 0, 0.8)",
            visible: false,
          },
          {
            olType: "cluster",
            title: "Byggesaker",
            layerId: "byggesak",
            url: parameters.geoJsonWFS + parameters.wfsTillegg,
            typeName: "byggesak_punkt_alle",
            layerInfo: true,
            featureInfo: true,
            fillColor: "rgba(255, 0, 0, 0.6)",
            textColor: "#fff",
            visible: false,
          },
          {
            olType: "cluster",
            title: "Postliste",
            layerId: "postliste",
            url: parameters.geoJsonWFS + parameters.wfsTillegg,
            typeName: "postliste_dato",
            layerInfo: true,
            featureInfo: true,
            fillColor: "rgba(138, 60, 255, 0.8)",
            textColor: "#fff",
            calendar: true,
            maxDateTo: "-2d",
            maxDateFrom: "-9d",
            visible: false,
          },
        ],
      },
      {
        olType: "group",
        layerId: "temakart",
        title: "Temakart",
        groupCheckbox: false,
        collapsible: true,
        layers: [
          {
            olType: "group",
            title:
              "Gul liste <span class='layer-title-small'>(kulturminner med eller uten formelt vern)</span>",
            layerId: "gulliste",
            layerInfo: true,
            groupCheckbox: true,
            visible: false,
            attribution: "©Byantikvaren",
            attributionId: "c-bya",
            layers: [
              {
                olType: "tile",
                title: "Kulturmiljø",
                layerId: "gl_kulturmiljo",
                url: parameters.gullisteUrl,
                layerName: "Kulturmiljo",
                visible: false,
              },
              {
                olType: "tile",
                title: "Sikringssone",
                layerId: "gl_sikringssone",
                url: parameters.gullisteUrl,
                layerName: "Sikringssone",
                visible: false,
              },
              {
                olType: "tile",
                title: "Lokaliteter",
                layerId: "gl_lokaliteter",
                url: parameters.gullisteUrl,
                layerName: "Lokaliteter",
                visible: false,
              },
              {
                olType: "tile",
                title: "Kulturminner",
                layerId: "gl_kulturminne",
                url: parameters.gullisteUrl,
                layerName: "Enkeltminner",
                visible: false,
              },
            ],
          },
          {
            olType: "tile",
            title: "Sannsynlighet for å finne fortidsminner",
            layerId: "funnpotensiale",
            url: parameters.funnpotensialeUrl,
            layerName: "Funnpotensiale",
            layerInfo: true,
            visible: false,
          },
          {
            olType: "tile",
            title: "Naturmangfold",
            layerId: "naturmangfold",
            url: parameters.naturmangfoldurl,
            layerName: "naturmangfold",
            attribution: "©Bym©Miljødirektoratet©Artsdatabanken",
            attributionId: "c-bymMiljodirektoratetArtsdatabanken",
            layerInfo: true,
            customLayerInfo:
              "<h3>Naturmangfold</h3><br /><h4>Tegnforklaring:</h4><div class='legend-row'><div class='legend-symb legend-verdifull-natur'>&nbsp;</div><div class='legend-text'>Verdifull natur</div></div><div class='legend-row'><div class='legend-symb legend-fremmede-arter'>&nbsp;</div><div class='legend-text'>Fremmede uønskede arter</div></div><br><h4>Verdifull natur (biologisk mangfold)</h4><p>Kartet viser blant annet vernede områder, kartlagte områder med verdifulle naturtyper og registrerte funn av rødlistede arter. Kommuneplanen har et eget temakart for naturmiljø som kun omfatter viktige naturtyper og som ikke er like oppdatert som kartet som vises her.</p><br /><h4>Fremmede uønskede arter</h4><p>Fremmede uønskede arter er arter som ikke hører hjemme i norsk natur og som medfører negative økologiske konsekvenser. I Oslo gjelder dette blant annet planteartene kjempebjørnekjeks, kjempespringfrø, russesvalerot og parkslirekne.</p></br><p><a href='https://od2.pbe.oslo.kommune.no/pages/vedlegg/naturmangfold.html' target='_blank'>Les mer om innholdet i kartlaget Naturmangfold.<i class='icon-new-window'></i></a></p>",
            visible: false,
          },
          {
            olType: "tile",
            title: "Forurenset grunn",
            layerId: "forurenset_grunn",
            url: parameters.forurensetgrunnurl,
            layerName: "forurenset_grunn",
            attribution: "©Miljødirektoratet",
            attributionId: "c-mdir",
            layerInfo: true,
            visible: false,
          },
          {
            olType: "tile",
            title: "Vann, bekker og elver",
            layerId: "vann",
            url: parameters.vannBekkerEleverurl,
            layerName: "Vann,Vannflater,Vannlinjer",
            attribution: "©VAV",
            attributionId: "c-vav",
            layerInfo: true,
            visible: false,
          },
          {
            olType: "group",
            layerId: "overvann",
            title: "Overvann",
            layerInfo: true,
            customLayerInfo:
              "<h3>Overvann</h3>Kartene viser resultater fra Oslo kommunes overvannsmodell og GIS-analyser. De utelukker ikke flomfare i andre områder, men er et godt utgangspunkt for videre undersøkelser. </p><p>Overvann skal håndteres i tråd med kommuneplanens bestemmelser pkt.24.1 og 24.2 og kommunens retningslinjer og veiledning for overvannshåndtering. ",
            collapsible: true,
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "wmts",
                title: "Modellert vanndybde (D)",
                layerId: "mikedybde",
                layerName: "Mike_Dybde",
                //url: "https://services-eu1.arcgis.com/Hky23fkHucfDZYMu/ArcGIS/rest/services/100KF_vanndybde_i_meter/FeatureServer",
                url: parameters.mapcacheurl,
                fillColor: "rgba(255, 255, 255, 1)",
                drawType: "stroke",
                layerInfo: true,
                featureInfo: true,
                customLayerInfo:
                  "<h3>Modellert vanndybde (D)</h3>Dette kartet viser maksimal modellert vanndybde (D) ved klimajustert 100-års regn. Kartet gir informasjon om arealer med risiko for skade ved en slik regnhendelse. Fargelagte risikointervaller synliggjør hvor stor faren er. Intervallene er hentet fra NVEs <a href='https://publikasjoner.nve.no/veileder/2022/veileder2022_04.pdf' target='_blank'>«Rettleiar for handtering av overvatn i arealplanar (4/22)»</a> , tabell 4-1. Kartet utelukker ikke oversvømmelsesfare i andre områder.<br /><br /><h3>Vanndybde (meter)</h3><img src='https://od2.pbe.oslo.kommune.no/cgi-bin/wms?map=AVRENNING&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&format=image/png&STYLE=default&layer=Mike_Dybde' alt='tegnforklaring for modellert vanndybde'></img><br /><br />For å gjøre Oslo til en mer robust by, må vi først vite hvor utfordringene ved styrtregn ligger og deretter planlegge tiltak for å løse dem. Dette gjelder både som sikringstiltak i etablert bebyggelse, prosjektering i byggesaker og ved all arealplanlegging.<br /><br /><b>For grunneiere</b> betyr det at de med dette kartet får et godt verktøy til å se hvor de kan bli berørt av overvann og hvor mye. Alle kan dermed sikre sin eiendom så godt som mulig mot at vannet renner inn gjennom dører, vinduer, innkjøring til garasjeanlegg, eller kan presse seg inn gjennom dreneringen og kjellervegger. <br/><br/><b>For profesjonelle</b> betyr det at de får bedre informasjon til å kunne planlegge og prosjektere hvordan de skal håndtere overvann basert på stedlige utfordringer og i tråd med <a href='https://www.oslo.kommune.no/get-file/282459/b106815ac7b30cfbe7427383fc7edf79577e3edf7162b3e31d67a12797f2391a' target='_blank'> kommunens retningslinjer og veiledning for overvannshåndtering. <i class='icon-new-window'></i></a>. Kartet skal benyttes som underlag ved planlegging og prosjektering av overvannshåndtering knyttet til alle slags prosjekter, reguleringsplaner og byggesaker og i forbindelse med risiko- og sårbarhetsanalyser (ROS-analyser) og konsekvensutredninger. </br></br> Kartet skal benyttes sammen med andre kart relatert til overvann og vassdrag. </br></br> Kartgrunnlaget er basert på resultater fra Oslos treveiskoblede hydrauliske overvannsmodell, en datamodell som simulerer både avrenning på terreng, i kommunalt ledningsnett og i vassdrag i en og samme modell. For mer informasjon om modellen, <a href='https://od2.pbe.oslo.kommune.no/pages/faktaark/Overvann.html' target='_blank'>se faktaarket Overvannsmodellen i Oslo kommune.</a> </br></br> Modellen blir aldri bedre enn de dataene som ligger til grunn. Vi oppfordrer derfor alle som opplever store regnhendelser eller skader som resultat av styrtregn, til <a href='https://survey123.arcgis.com/share/ddf18a53b7684b0ca6f3bee2fca1c8cb' target='_blank'> å dele sine bilder og videoer med oss på denne siden</a> og dermed bidra til verifisering av modellresultater.",
                visible: false,
              },
              {
                olType: "wmts",
                title: "Modellert dybdeintegrert hastighet (DV)",
                layerId: "mikedv",
                url: parameters.mapcacheurl,
                layerName: "Mike_Avrenning",
                layerInfo: true,
                customLayerInfo:
                  "<h3>Modellert dybdeintegrert hastighet (DV)</h3>Dette kartet viser modellert maksimal dybdeintegrert hastighet (DV) ved klimajustert 100-års regn. DV beregnes som D x V, altså dybde multiplisert med hastighet. Kartet viser arealer med potensial for risiko for skade ved en slik regnhendelse, altså når gjenstander og mennesker i gaten kan bli revet med vannstrømmen og når vannmassene kan føre til erosjon og skred. Fargelagte risikointervaller synliggjør hvor stor faren er. Intervallene er hentet fra NVEs <a target='_blank' href='https://publikasjoner.nve.no/veileder/2022/veileder2022_04.pdf\'>«Rettleiar for handtering av overvatn i arealplanar (4/22)» <i class='icon-new-window'></i></a>, tabell 4-1. Kartet utelukker ikke oversvømmelsesfare i andre områder.<br/><br/><h4>Dybdeintegrert hastighet (vannføring i m³/s per meter)</h4><img src='https://od2.pbe.oslo.kommune.no/cgi-bin/wms?map=AVRENNING&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&format=image/png&STYLE=default&layer=Mike_Avrenning' alt='tegnforklaring for dybdeintegrert hastighet'></img> <br/><br/>For å gjøre Oslo til en mer robust by, må vi først vite hvor utfordringene ved styrtregn ligger og deretter planlegge tiltak for å løse dem. Dette gjelder både som sikringstiltak i etablert bebyggelse, prosjektering i byggesaker og ved all arealplanlegging.<br/><br/><b>For grunneiere</b> betyr det at de med dette kartet får et godt verktøy til å se hvor de kan bli berørt av store vannstrømmer enten i form av stor vannføring eller små vannmengder med stor hastighet, og hvor farlig det kan bli. Alle kan dermed sikre sin eiendom så godt som mulig mot at vannet strømmer inn gjennom dører, vinduer, innkjøring til garasjeanlegg, eller kan presse seg inn gjennom dreneringen, kjellervegger og til og med kjellergulv. Vannmassene kan ødelegge innkjørselen, få asfalten i gaten til å skrelles av og gjøre store skader på konstruksjoner som støttemurer o.l. Områder utsatt for disse vannstrømmene bør gi vannet plass – la det renne forbi og sikre boligen mot kontakt med disse vannstrømmene. <br/><br/><b>For profesjonelle</b> betyr det at de får bedre informasjon til å kunne planlegge og prosjektere hvordan de skal håndtere overvann basert på stedlige utfordringer og i tråd med kommunens <a target='_blank' href=\"https://www.oslo.kommune.no/get-file/282459/b106815ac7b30cfbe7427383fc7edf79577e3edf7162b3e31d67a12797f2391a .\">Retningslinjer og veiledning for overvannshåndtering <i class='icon-new-window'></i></a> Kartet skal benyttes som underlag ved planlegging og prosjektering av overvannshåndtering knyttet til alle slags prosjekter, reguleringsplaner og byggesaker og i forbindelse med risiko- og sårbarhetsanalyser (ROS-analyser) og konsekvensutredninger. <br/><br/>Kartet skal benyttes sammen med andre kart relatert til overvann og vassdrag.<br/><br/>Kartgrunnlaget er basert på resultater fra Oslos treveiskoblede hydrauliske overvannsmodell, en datamodell som simulerer både avrenning på terreng, i kommunalt ledningsnett og i vassdrag i en og samme modell. For mer informasjon om modellen, se faktaarket <a href='https://od2.pbe.oslo.kommune.no/pages/faktaark/Overvann.html' target='_blank'> Overvannsmodellen i Oslo kommune.<i class='icon-new-window'></i></a><br /><br />Modellen blir aldri bedre enn de dataene som ligger til grunn. Vi oppfordrer derfor alle som opplever store regnhendelser eller skader som resultat av styrtregn, <a href='https://survey123.arcgis.com/share/ddf18a53b7684b0ca6f3bee2fca1c8cb' target='_blank'>til å dele sine bilder og videoer med oss på denne siden<i class='icon-new-window'></i></a> og dermed bidra til verifisering av modellresultater.",
                visible: false,
              },
              {
                olType: "tile",
                title: "Vannveier2",
                layerId: "vann2",
                displayInLayerMenu: false,
                url: parameters.vannBekkerEleverurl,
                layerName: "Vannflater,Vannlinjer",
                attribution: "©VAV",
                attributionId: "c-vav",
                layerInfo: false,
                visible: false,
              },
              {
                olType: "tile",
                title: "Vannveier3",
                layerId: "vann3",
                displayInLayerMenu: false,
                url: parameters.vannBekkerEleverurl,
                layerName: "Vannflater,Vannlinjer",
                attribution: "©VAV",
                attributionId: "c-vav",
                layerInfo: false,
                visible: false,
              },
              {
                olType: "wmts",
                title: "Avrenningsmønster",
                layerId: "avrenning",
                url: parameters.mapcacheurl,
                layerName: "avrenning",
                altSource: {
                  url: parameters.avrenningURL,
                  layerName: "avrenningsmønster",
                },
                layerInfo: true,
                customLayerInfo:
                  "<h3>Avrenningsmønster</h3><p>Avrenningsmønsteret er en samling av mange avrenningslinjer (tidl. kalt dreneringslinjer). Mønsteret simulerer hvordan avrenningslinjene kan påvirkes av unøyaktigheter i terrengmodellen, ujevnheter i terrenget og ulik vannhastighet og dybde. Det viser at overvann kan ta flere veier, ikke bare den bratteste. Avrenningsmønsteret viser derfor usikkerheten knyttet til hver avrenningslinje. Mørk farge betyr at mange avrenningslinjer med stort nedslagsfelt sammenfaller.<br /><br />Overvann skal håndteres i tråd med kommuneplanens bestemmelser pkt. 24.1 og 24.2 og kommunens <i><a target='_blank' href=\"https://www.oslo.kommune.no/get-file/282459/b106815ac7b30cfbe7427383fc7edf79577e3edf7162b3e31d67a12797f2391a .\">Retningslinjer og veiledning for overvannshåndtering <i class='icon-new-window'></i></a>.</i><br /><br />Dette kartet skal brukes sammen med de andre overvannskartene for å få oversikt over hva man kan forvente i forhold til overvann i området.<br /><br /><b>Her kan du lese mer</b><ul><li><a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2023088702&fileid=10883926\">Faktaark om avrenningslinjer og avrenningsmønster <i class='icon-new-window'></i></a></li><li><a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2023088702&fileid=10883952\">Artikkel om avrenningsmønster i Vann 02 2023 <i class='icon-new-window'></i></a></li><li>NVEs <a target='_blank' href=\"https://publikasjoner.nve.no/veileder/2022/veileder2022_04.pdf\">«Rettleiar for handtering av overvatn i arealplanar (4/22)» <i class='icon-new-window'></i></a></li><li><a target='_blank' href=\"https://www.oslo.kommune.no/get-file/282459/b106815ac7b30cfbe7427383fc7edf79577e3edf7162b3e31d67a12797f2391a .\">Retningslinjer og veiledning for overvannshåndtering <i class='icon-new-window'></i></a></li><li><a href='https://www.oslo.kommune.no/get-file/1125932/a5aa1fab56d1c7b655ddbb55331e12cbaec8293b30074db1d058f9ae898a1bd4' target='_blank'> Kommuneplan arealdel <i class='icon-new-window'></i></a></li></ul>",
                visible: false,
                dependent: "vann2",
              },
              {
                olType: "tile",
                title: "Avrenningslinjer (Dreneringslinjer)",
                layerId: "drenering",
                url: parameters.avrenningURL,
                layerName: "Dreneringslinjer",
                layerInfo: true,
                /*Denne overstyrer info som ligger et annet sted*/
                customLayerInfo:
                  "<h3>Avrenningslinjer (Dreneringslinjer)</h3>Kartet avrenningslinjer (tidligere kalt dreneringslinjer) viser resultater fra en enkel matematisk beregning av hvor overvann vil renne fra høyereliggende til lavereliggende arealer basert på terrengform og helning. Det tar ikke hensyn til vannmengder, overflater, rørsystem og infiltrasjon. Dette kan derfor sees på som en beregning av hvor det er sannsynlig at vannet vil renne dersom kulverter, stikkrenner og rørsystem er utilgjengelig.<br /><br />Overvann skal håndteres i tråd med kommuneplanens bestemmelser pkt. 24.1 og 24.2 og kommunens <a target='_blank' href=\"https://www.oslo.kommune.no/get-file/282459/b106815ac7b30cfbe7427383fc7edf79577e3edf7162b3e31d67a12797f2391a .\">retningslinjer og veiledning for overvannshåndtering <i class='icon-new-window'></i></a>.<br /><br />Dette kartet skal brukes sammen med de andre overvannskartene for å få oversikt over hva man kan forvente i forhold til overvann i området.<br /><br /><b>Her kan du lese mer</b><ul><li><a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2023088702&fileid=10883926\">Faktaark om avrenningslinjer og avrenningsmønster <i class='icon-new-window'></i></a></li><li>NVEs <a target='_blank' href=\"https://publikasjoner.nve.no/veileder/2022/veileder2022_04.pdf\">«Rettleiar for handtering av overvatn i arealplanar (4/22)» <i class='icon-new-window'></i></a></li><li><a href='https://www.oslo.kommune.no/get-file/1125932/a5aa1fab56d1c7b655ddbb55331e12cbaec8293b30074db1d058f9ae898a1bd4' target='_blank'> Kommuneplan arealdel <i class='icon-new-window'></i></a></li></ul>",
                visible: false,
                dependent: "vann3",
              },
              {
                olType: "image",
                title: "Overvannsrør med direkte utløp til sjø og vassdrag",
                layerId: "Overvannsror",
                url: parameters.avrenningURL,
                layerName: "Overvannsrør",
                layerInfo: true,
                customLayerInfo:
                  '<h3>Overvannsrør til sjø og vassdrag</h3>Overvannsrør nærmere enn 250 meter fra sjø eller vassdrag  hvor overvann kan slippes på uten fordrøyning dersom vilkår i retningslinjer og veiledning for overvannshåndtering i Oslo  er oppfylt.<br/><br/><img src="' +
                  parameters.avrenningURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Overvannsrør&format=image/png">',
                visible: false,
              },
            ],
          },
          {
            olType: "tile",
            title: "Konsesjonsområde for fjernvarme",
            layerId: "fjernvarme",
            url: parameters.fjernvarmeurl,
            layerName: "Fjernvarme",
            layerInfo: true,
            visible: false,
          },
          {
            olType: "tile",
            title: "Veitype",
            layerId: "veitype",
            url: parameters.vegtypeurl,
            layerName: "Kategori",
            layerInfo: true,
            visible: false,
          },
          {
            olType: "image",
            title: "Fartsgrenser",
            layerId: "fartsgrenser",
            url: parameters.fartsgrenserurl,
            zIndex: 200,
            layerName: "Fartsgrenser",
            layerInfo: true,
            visible: false,
          },
          {
            olType: "vector",
            title: "Trafikkmengde",
            layerId: "trafikkmengde",
            url: parameters.trafikkmengdeurl + parameters.wfsTillegg,
            typeName: "AADT_fastskala",
            attribution: "©Vegvesenet",
            attributionId: "c-veg",
            fillColor: "rgba(255, 255, 255, 1)",
            attribute: "AADT_TOTAL",
            dependent: "AADT_fastskala",
            layerInfo: true,
            featureInfo: true,
            visible: false,
          },
          {
            olType: "image",
            title:
              "Blågrønn faktor <span class='layer-title-small'>(Norm for vegetasjon og vannhåndtering)</span>",
            layerId: "blagronn_faktor",
            layerName: "blagronn_faktor",
            url: parameters.blagronnurl,
            typeName: "blagronn_faktor",
            layerInfo: true,
            featureInfo: false,
            visible: false,
          },
          {
            olType: "image",
            title: "Friluftslivsområder",
            layerId: "friluft",
            layerName: "friluft",
            url: parameters.friluftUrl,
            typeName: "friluft",
            layerInfo: true,
            featureInfo: false,
            visible: false,
            attribution: "©Miljødirektoratet",
            attributionId: "c-mdir",
            customLayerInfo:
              "<h3>Friluftslivsområder</h3><h4>Kartlagte friluftslivsområder</h4><p>Kartet viser registrerte friluftslivsområder, leke- og rekreasjonsområder og lignende, hentet fra Miljødirektoratets karttjeneste (NaturBase). Dataene vil oppdateres ettersom flere kartlegginger gjennomføres. Kartleggingen er gjort uavhengig av hva eiendommene er regulert til. </p><p>Kartet skal brukes som kunnskapsgrunnlag i plan- og byggesaksbehandling, for å identifisere og ivareta arealer som er viktige for allmennhetens friluftsliv. Kommunen skal blant annet påse at vesentlige konsekvenser for friluftsliv blir utredet i plansaker, i henhold til plan- og bygningsloven §§4-1 og 4-2.</p><p>I høyre-menyen, Om valgt eiendom, kan man finne mer info knyttet til kartleggingen av den enkelte eiendommen (NaturBase - faktaark). </p><p>Her kan du finne ut mer om friluftsområdene: <ul><li><a href=\"https://geocortex02.miljodirektoratet.no/Html5Viewer/?viewer=naturbase\" target='_blank'>NaturBase kart<i class='icon-new-window'></i></a></li><li><a href =\"https://www.miljodirektoratet.no/globalassets/publikasjoner/m98/m98.pdf\" target='_blank'>Veileder for kartlegging og verdsetting av friluftslivsområder<i class='icon-new-window'></i></a></li></ul><img src=\"" +
              parameters.friluftUrl +
              '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Kartlagte friluftslivsområder&format=image/png&STYLE=default"><h4>Statlig sikra friluftslivsområder</h4><img src="' +
              parameters.friluftUrl +
              '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Statlig sikra friluftslivsområder&format=image/png&STYLE=default">',
          },
          {
            olType: "group",
            layerId: "grunnforhold",
            title: "Grunnforhold",
            collapsible: true,
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "tile",
                title: "Marin grense",
                layerId: "maringrense",
                url: parameters.risikourl,
                layerName: "Maringrense",
                layerInfo: true,
                visible: false,
              },
              {
                olType: "image",
                title: "Dybde til antatt berg",
                layerId: "Dybde_til_fjell",
                url: parameters.grunnforholdURL,
                layerName: "Dybde_til_fjell",
                visible: false,
                displayInLayerMenu: true,
                groupCheckbox: true,
                layerInfo: true,
                customLayerInfo:
                  '<h3>Dybde til antatt berg</h3><p>Kartet viser dybde til antatt berg i meter for byggesonen i Oslo kommune.</p><p><b>Usikkerheter i kartet</b></p><p>Boringene som kartet er basert på er utført med ulike metoder og på ulike tidspunkter, det er ikke heller alle boringer som har funnet fjell. Kartet inneholder derfor usikkerheter. Dybde til bergkartet viser bare informasjon om dybder til berg som er nærmere enn 50 meter fra en boring. Vi anbefaler at kartet brukes som veiledende informasjon. Kartet er laget i 2016.</p><p><b>Hvor kommer informasjonen i kartet fra?</b></p><p>Kartet er basert på 186 260 borepunkter som er hentet fra flere ulike kilder og behandlet (interpolert) i et geografisk informasjonssystem (GIS).</p><p>Boringene er hentet fra Oslo kommunes undergrunnsarkiv, kommunens grunnvannsdatabase, NADAG (Nasjonal database for grunnundersøkelser) og GRANADA (Nasjonal grunnvannsdatabase).</p><p>Oslo kommunes undergrunnsarkiv inneholder geotekniske boringer gjennomført i Oslo de siste 100 årene.</p><p>Du kan få detaljert informasjon om boringen og dens resultater ved å lese hele rapporten. Rapporter fra grunnundersøkelser i undergrunnsarkivet kan bestilles fra <a href="mailto:dig.kart@pbe.oslo.kommune.no">dig.kart@pbe.oslo.kommune.no</a></p><p>NADAG og GRANADA driftes av NGU (Norges geologiske undersøkelse) og er tilgjengelig på <a target=_blank href="http://geo.ngu.no/kart/nadag/">http://geo.ngu.no/kart/nadag <i class=\'icon-new-window\'></i></a> og <a target=_blank href="http://geo.ngu.no/kart/granada/">http://geo.ngu.no/kart/granada <i class=\'icon-new-window\'></i></a><img src="' +
                  parameters.grunnforholdURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Dybde_til_fjell&format=image/png">',
                //legend: parameters.grunnforholdURL + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Dybde_til_fjell&format=image/png",
              },
              {
                olType: "image",
                title: "Borepunkter hvor leire er påvist",
                layerId: "Leire",
                url: parameters.grunnforholdURL,
                layerName: "Leire",
                visible: false,
                displayInLayerMenu: true,
                groupCheckbox: true,
                layerInfo: true,
                customLayerInfo:
                  '<h3>Borepunkter hvor leire er påvist</h3><p>Kart som viser borepunkter hvor leire er påvist, viser digitalisert informasjon fra Oslo kommunes undergrunnsarkiv – et arkiv som inneholder geotekniske boringer gjennomført i Oslo de siste 100 årene.</p><p><b>Usikkerheter i kartet</b></p><p>Per i dag har vi ikke digitalisert all informasjon om Oslo i kommunens undergrunnsarkiv. Derfor finner du heller ikke digitalisert informasjon fra hele Oslo i karttjenesten.</p><p>Funn av leire i et borepunkt er ikke det samme som at det ikke er funnet kvikkleire i et borepunkt. Det kan rett og slett være at det ikke er gjennomført boringer og tester som viser om det er kvikkleire eller ikke i et område.</p><p>Du kan få detaljert informasjon om boringen og dens resultater ved å lese hele rapporten. Rapporter fra grunnundersøkelser i undergrunnsarkivet kan bestilles fra <a href="mailto:dig.kart@pbe.oslo.kommune.no">dig.kart@pbe.oslo.kommune.no</a></p><p>Kartet er oppdatert 4.8.2022</p><img src="' +
                  parameters.grunnforholdURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Leire&format=image/png">',
                //legend: parameters.grunnforholdURL + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Leire&format=image/png",
              },
              {
                olType: "image",
                title: "Borepunkter hvor kvikkleire er påvist",
                layerId: "Kvikkleire",
                url: parameters.grunnforholdURL,
                layerName: "Kvikkleire",
                visible: false,
                displayInLayerMenu: true,
                groupCheckbox: true,
                layerInfo: true,
                customLayerInfo:
                  '<h3>Borepunkter hvor kvikkleire er påvist</h3><p>Kart som viser borepunkter hvor kvikkleire er påvist, viser digitalisert informasjon fra Oslo kommunes undergrunnsarkiv – et arkiv som inneholder geotekniske boringer gjennomført i Oslo de siste 100 årene. Funn av kvikkleire i et borepunkt er ikke det samme som risiko for kvikkleireskred i et område.</p><p>Du kan lese mer om kvikkleire på NVEs hjemmesider: <a target=_blank href="https://www.nve.no/om-nve/spor-nve/om-kvikkleire/">https://www.nve.no/om-nve/spor-nve/om-kvikkleire <i class=\'icon-new-window\'></i></a></p><p>Har du, eller skal du utføre geotekniske boringer i Oslo? For å sikre gjenbruk så anbefaler vi at dataene deles i Norges Nasjonale database for grunnundersøkelser, NADAG.</p><p><b>Usikkerheter i kartet</b></p><p>Per i dag har vi ikke digitalisert all informasjon i Oslo kommunes undergrunnsarkiv. Derfor finner du heller ikke digitalisert informasjon fra hele Oslo i karttjenesten.</p><p>Definisjonene av kvikkleire har endret seg over tid. Det betyr at det som har vært definert som kvikkleire historisk, ikke nødvendigvis defineres som kvikkleire i dag. Du kan få detaljert informasjon om boringen og dens resultater ved å lese hele rapporten. Rapporter fra grunnundersøkelser i undergrunnsarkivet kan bestilles fra <a href="mailto:dig.kart@pbe.oslo.kommune.no">dig.kart@pbe.oslo.kommune.no</a></p><p>Kartet er oppdatert 4.8.2022</p><img src="' +
                  parameters.grunnforholdURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Kvikkleire&format=image/png">',
                //legend: parameters.grunnforholdURL + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Kvikkleire&format=image/png",
              },
              {
                olType: "image",
                title: "Påviste kvikkleiresoner fra NVE",
                layerId: "KvikkleireFaregrad_NVE",
                url: "https://kart.nve.no/enterprise/services/SkredKvikkleire2/MapServer/WmsServer",
                layerName: "KvikkleireFaregrad",
                visible: false,
                displayInLayerMenu: true,
                groupCheckbox: true,
                layerInfo: true,
                customLayerInfo:
                  '<h3>Kvikkleiresoner fra </h3>Data fra Norges vassdrags- og energidirektorat (NVE).</p><p>Kvikkleiresone er et område hvor det er risiko for kvikkleireskred. En kvikkleiresone består av to soner: et løsneområde og et utløpsområde. Løsneområdet er der skredet starter, og utløpsområdet er området som blir eller kan bli rammet av skredet.</p><p>Se også <a target = _blank href="https://register.geonorge.no/data/documents/Produktark_Kvikkleire_v4_kvikkleire11012019_.pdf">«Produktark: Kvikkleire» fra NVE / Norge digitalt <i class=\'icon-new-window\'></i></a></p><img src="https://kart.nve.no/enterprise/services/SkredKvikkleire2/MapServer/WmsServer?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=KvikkleireFaregrad&format=image/png">',
                attribution: "©NVE",
                attributionId: "c-nve",
                //legend: "https://kart.nve.no/enterprise/services/SkredKvikkleire2/MapServer/WmsServer?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=KvikkleireFaregrad&format=image/png"
              },
              {
                olType: "image",
                title: "Observasjoner av fjell i dagen",
                layerId: "Fjellidagen",
                url: parameters.grunnforholdURL,
                layerName: "Fjellidagen",
                visible: false,
                displayInLayerMenu: true,
                groupCheckbox: true,
                layerInfo: true,
                customLayerInfo:
                  '<h3>Kart som viser observasjoner av berg i dagen</h3>Kartet viser hvor det er observert berg. Datasettet er samlet inn over lang tid og de aller fleste punktene er kartlagt gjennom befaring.</p><p>Det finnes ikke informasjon om bergart i denne kartløsningen. Informasjon om bergart kan du finne i <a target=_blank href="https://geo.ngu.no/kart/berggrunn_mobil/">NGUs nasjonale berggrunnsdatabase <i class=\'icon-new-window\'></i></a><img src="' +
                  parameters.grunnforholdURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Fjellidagen&format=image/png">',
                //legend: parameters.grunnforholdURL + "&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Fjellidagen&format=image/png",
              },
            ],
          },
          {
            olType: "group",
            layerId: "flom",
            title: "Flom i elver og bekker",
            layerInfo: false,
            collapsible: true,
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "tile",
                title: "NVEs aktsomhetssoner for elveflom ",
                layerId: "elveflom",
                url: "https://kart.nve.no/enterprise/services/FlomAktsomhet/MapServer/WmsServer?",
                layerName: "Flom_aktsomhetsomrade,MaksimalVannstandstigning",
                layerInfo: true,
                customLayerInfo:
                  '<h3>NVEs aktsomhetssoner for elveflom</h3>Nasjonalt aktsomhetskart som på oversiktsnivå viser hvilke arealer som kan være utsatt for flomfare fra vassdrag. Kartet er laget fra den landsdekkende høydemodellen med oppløsning på 10x10 meter og FKB - vann (grunnkartet). Mer informasjon om kartet finnes <a target=\'_blank\' href="https://www.nve.no/naturfare/utredning-av-naturfare/om-kart-og-kartlegging-av-naturfare/om-kartlegging-av-flaumfare/aktsomhetskart-for-flom/">hos Norges vassdrags- og energidirektorat <i class=\'icon-new-window\'></i></a><br /><img src="https://kart.nve.no/enterprise/services/FlomAktsomhet/MapServer/WMSServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=MaksimalVannstandstigning&format=image/png"><br /><br /><img src="https://kart.nve.no/enterprise/services/FlomAktsomhet/MapServer/WMSServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Flom_aktsomhetsomrade&format=image/png">',
                visible: false,
              },
              {
                olType: "tile",
                title: "Initial 1000-års flom for regulerte vassdrag",
                layerId: "initial",
                url: parameters.flomURL,
                layerName: "Initialflom",
                layerInfo: true,
                customLayerInfo:
                  '<h3>Initial 1000-års flom for regulerte vassdrag</h3>Initial 1000-års flom i de regulerte vassdragene Akerselva, Alna og Ljanselva. Dette er en grov beregning gjort i forbindelse med dambruddsbølgeberegninger.<br /><img src="' +
                  parameters.flomURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Initialflom&format=image/png">',
                visible: false,
              },
              {
                olType: "tile",
                title: "Flomsonekart fra NVE",
                layerId: "Flomsonekart",
                url: parameters.flomURL,
                layerName: "Flomsonekart",
                layerInfo: true,
                customLayerInfo:
                  "<h3>Flomsonekart fra NVE</h3>Rapporter fra NVE:<ul><li><a target='_blank' href=\"https://publikasjoner.nve.no/flomsonekart/2010/flomsonekart2010_06.pdf\">Flomsonekart for Sørkedalselva <i class='icon-new-window'></i></a></li><li><a target='_blank' href=\"https://publikasjoner.nve.no/flomsonekart/2010/flomsonekart2010_01.pdf\">Flomsonekart for Ellingsrudelva <i class='icon-new-window'></i></a></li></ul><br /><img src=\"" +
                  parameters.flomURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Flomsonekart&format=image/png">',
                visible: false,
              },
            ],
          },
          {
            olType: "group",
            title: "Skred i bratt terreng",
            layerId: "bratt",
            layerInfo: true,
            customLayerInfo:
              "<h3>Skred i bratt terreng</h3><p>Skred i bratt terreng omfatter skredtypene snøskred, sørpeskred, flomskred, jordskred, steinsprang og steinskred. Hvilke skredprosesser som kan være aktuelle avhenger av faktorer som helning, løsmassedekke, type berg, forekomst og plassering av sprekker og forvitringssoner i berg, vegetasjon og skog, samt vannsig og bekkeløp.</p><p>Her kan du lese mer om skred i bratt terreng:<ul><li><a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2023037534&fileid=10696208\">Kart for skred i bratt terreng  <i class='icon-new-window'></i></a></li><li>Kommuneplanens bestemmelser 4.3</li><li>ROS-analysen om skred i bratt terreng</li></ul>",
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "tile",
                title: "Helningskart fra NVE",
                layerId: "skred1",
                url: "https://kart.nve.no/enterprise/services/Bratthet/MapServer/WMSServer?",
                layerName: "Bratthet_jordskred",
                layerInfo: true,
                visible: false,
                customLayerInfo:
                  '<h3>Helningskart fra NVE</h3>Nasjonalt bratthetskart fra NVE til vurdering av skredfare i bratt terreng.<p><ul><li>Steinsprang og steinskred skal vurderes i og under skråninger brattere enn 45 grader</li><li>Snøskred skal vurderes i og under skråninger brattere enn 25 grader</li><li>Jordskred/løsmasseskred skal vurderes i og under skråninger brattere enn 20 grader</li><li>Flomskred skal vurderes i forsenkninger og bekkeløp brattere enn 15 grader</li><li>Sørpeskred skal vurderes der det er forsenkninger eller bekkeløp som kan samle opp vann i snødekket</li></ul><br/><img src="https://kart.nve.no/enterprise/services/Bratthet/MapServer/WMSServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Bratthet_jordskred&format=image/png">',
                attribution: "©NVE",
                attributionId: "c-nve",
              },
              {
                olType: "tile",
                title: "Nasjonale aktsomhetskart Steinsprang",
                layerId: "skred2",
                url: "https://kart.nve.no/enterprise/services/SkredSteinAktR/MapServer/WmsServer?",
                layerName: "Utlosningsomrade,Utlopsomrade",
                layerInfo: true,
                visible: false,
                customLayerInfo:
                  '<h3>Nasjonale aktsomhetskart Steinsprang</h3>Nasjonalt aktsomhetskart som viser potensielle løsne- og utløpsområder for steinsprang. Kartet er laget fra den landsdekkende høydemodellen med oppløsning på 25x25 meter. Denne glatter ut terrenget og små skrenter og terrasser i terrenget skjules. Det kan derfor være skredutsatte områder også utenfor aktsomhetssone. Mer informasjon om kartet finnes <a target=\'_blank\' href=" https://www.nve.no/naturfare/utredning-av-naturfare/om-kart-og-kartlegging-av-naturfare/om-kartlegging-av-skredfare-i-bratt-terreng/aktsomhetskart-for-steinsprang/">hos Norges vassdrags- og energidirektorat <i class=\'icon-new-window\'></i></a><br/><img src="https://kart.nve.no/enterprise/services/SkredSteinAktR/MapServer/WmsServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Utlosningsomrade&format=image/png"><br /><img src="https://kart.nve.no/enterprise/services/SkredSteinAktR/MapServer/WmsServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Utlopsomrade&format=image/png">',
                attribution: "©NVE",
                attributionId: "c-nve",
              },
              {
                olType: "tile",
                title: "Nasjonale aktsomhetskart Snøskred",
                layerId: "skred3",
                url: "https://kart.nve.no/enterprise/services/SkredSnoAktR/MapServer/WmsServer?",
                layerName: "Utlosningsomrade,Utlopsomrade",
                layerInfo: true,
                visible: false,
                customLayerInfo:
                  '<h3>Nasjonale aktsomhetskart Snøskred</h3>Nasjonalt aktsomhetskartet som viser potensielle løsne- og utløpsområder for snøskred. Kartet er laget fra den landsdekkende høydemodellen med oppløsning på 25x25 meter. Denne glatter ut terrenget og små skrenter og terrasser i terrenget skjules. Det kan derfor være skredutsatte områder også utenfor aktsomhetssone. Mer informasjon om kartet finnes <a target=\'_blank\' href=" https://www.nve.no/naturfare/utredning-av-naturfare/om-kart-og-kartlegging-av-naturfare/om-kartlegging-av-skredfare-i-bratt-terreng/aktsomhetskart-for-snoskred/">hos Norges vassdrags- og energidirektorat <i class=\'icon-new-window\'></i></a><br/><img src="https://kart.nve.no/enterprise/services/SkredSnoAktR/MapServer/WmsServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Utlosningsomrade&format=image/png"><br /><img src="https://kart.nve.no/enterprise/services/SkredSnoAktR/MapServer/WmsServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Utlopsomrade&format=image/png">',
                attribution: "©NVE",
                attributionId: "c-nve",
              },
              {
                olType: "tile",
                title: "Nasjonale aktsomhetskart Jord-Flomskred",
                layerId: "skred4",
                url: "https://kart.nve.no/enterprise/services/SkredJordFlomAktR1/MapServer/WmsServer?",
                layerName: "Potensielt_Jord-Flomskredfare",
                layerInfo: true,
                visible: false,
                attribution: "©NVE",
                attributionId: "c-nve",
                customLayerInfo:
                  "<h3>Nasjonale aktsomhetskart Jord-Flomskred</h3>Nasjonalt aktsomhetskartet som viser områder med potensiell fare for jord- og flomskred. Kartet er laget fra den landsdekkende høydemodellen med oppløsning på 10x10 meter. Denne glatter ut terrenget og små skrenter og terrasser i terrenget skjules. Det kan derfor være skredutsatte områder også utenfor aktsomhetssone. Mer informasjon om kartet finnes <a target='_blank' href=\" https://www.nve.no/naturfare/utredning-av-naturfare/om-kart-og-kartlegging-av-naturfare/om-kartlegging-av-skredfare-i-bratt-terreng/aktsomhetskart-for-jord-og-flomskred/\">hos Norges vassdrags- og energidirektorat <i class='icon-new-window'></i></a><br/><img src=\"https://kart.nve.no/enterprise/services/SkredJordFlomAktR1/MapServer/WmsServer?&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Potensielt_Jord-Flomskredfare&format=image/png\">",
              },
              {
                olType: "tile",
                title: "Kommunal helningsanalyse med 5 meter filter",
                layerId: "skred5",
                url: parameters.kartlagtURL,
                layerName: "Helningsanalyse",
                layerInfo: true,
                visible: false,
                customLayerInfo:
                  "<h3>Kommunal helningsanalyse med 5 meter filter</h3>Kommunal helningsanalyse med 5 meter filter viser potensielle løsne- og utløpsområder for steinsprang i skråninger høyere enn 5 meter. Kartet er laget fra en kommunal høydemodell med oppløsning på 2x2 meter. </p><p>Mer informasjon om kartet finnes i <a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2023037534&fileid=10694324\">faktaarket <i class='icon-new-window'></i></a><br /><br/><img src=\"" +
                  parameters.kartlagtURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Helningsanalyse&format=image/png">',
              },
              {
                olType: "tile",
                title: "Kartlegginger utført av fagkyndig konsulentfirma",
                layerId: "skred6",
                url: parameters.kartlagtURL,
                layerName: "Steinsprangkartlegging",
                layerInfo: true,
                visible: false,
                customLayerInfo:
                  "<h3>Kartlagte aktsomhetsområder for steinsprang i Oslo kommune</h3><p>Kartleggingen er utført av fagkyndige og resultatene er beskrevet i følgende rapporter:</p><ul><li><a target='_blank' href=\"https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2012086229&fileid=3679699\">NGI Rapport 20110386 «Planområde Gjersrud-Stensrud skredfarevurdering» <i class='icon-new-window'></i></a></li><li><a target='_blank' href=\"https://od2.pbe.oslo.kommune.no/pages/steinsprangRapport/NGI_Rapport%2020111221%20Aktsomhetskartlegging%20for%20steinsprang%20i%20Oslo%20(kart%201-13).pdf\">NGI Rapport 20110826 «Aktsomhetskartlegging for steinsprang i Oslo kommune» kart 1-13<i class='icon-new-window'></i></a>  (Sak 201009909) </li><li><a target='_blank' href=\"https://od2.pbe.oslo.kommune.no/pages/steinsprangRapport/NGI_Rapport%2020120620%20Aktsomhetskartlegging%20for%20steinsprang%20i%20Oslo%20Revisjon%201%20(kart%2014-31).pdf\">NGI Rapport 20110826 «Aktsomhetskartlegging for steinsprang i Oslo kommune» kart 14-31<i class='icon-new-window'></i></a>  (Sak 201009909) </li><li><a target='_blank' href=\"https://od2.pbe.oslo.kommune.no/pages/steinsprangRapport/NGI Rapport 20110826 «Aktsomhetskartlegging for steinsprang i Oslo kommune» (revidert).pdf\">NGI Rapport 20110826 «Aktsomhetskartlegging for steinsprang i Oslo kommune» (revidert)<i class='icon-new-window'></i></a> (Sak 201009909) </li><li><a target='_blank' href=\"https://od2.pbe.oslo.kommune.no/pages/steinsprangRapport/Multiconsult_Rapport%2020101221%20Utvalgte%20omr%C3%A5der%20for%20vurdering%20av%20steinsprangfare.pdf\">Multiconsult Rapport 20101221 «Utvalgte områder for vurdering av steinsprangfare» <i class='icon-new-window'></i></a>  (Sak 201009909) </li></ul><br /><br/><img src=\"" +
                  parameters.kartlagtURL +
                  '&version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=Steinsprangkartlegging&format=image/png">',
              },
            ],
          },
        ],
      },
      {
        olType: "group",
        layerId: "historiskeflyfoto",
        title: "Historiske flyfoto",
        collapsible: true,
        groupCheckbox: false,
        layers: [
          {
            olType: "tile",
            title: "Oslo - 1937",
            layerId: "flyfoto-1937",
            url: parameters.flyfotoHist,
            layerName: "Flyfoto_1937",
            epsg: "EPSG:32632",
            radio: true,
            visible: false,
          },
          {
            olType: "tile",
            title: "Oslo - 1947",
            layerId: "flyfoto-1947",
            url: parameters.flyfotoHist,
            layerName: "Flyfoto_1947",
            epsg: "EPSG:32632",
            radio: true,
            visible: false,
          },
          {
            olType: "tile",
            title: "Oslo - 1971",
            layerId: "flyfoto-1971",
            url: parameters.flyfotoHist,
            layerName: "Flyfoto_1971",
            epsg: "EPSG:32632",
            radio: true,
            visible: false,
          },
          {
            olType: "tile",
            title: "Oslo - 1984",
            layerId: "flyfoto-1984",
            url: parameters.flyfotoHist,
            layerName: "Flyfoto_1984",
            epsg: "EPSG:32632",
            radio: true,
            visible: false,
          },
          {
            olType: "tile",
            title: "Oslo - 1997",
            layerId: "flyfoto-1997",
            url: parameters.flyfotoHist,
            layerName: "Flyfoto_1997",
            epsg: "EPSG:32632",
            radio: true,
            visible: false,
          },
          {
            olType: "tile",
            title: "Ingen",
            layerId: "no_historisk_flyfoto",
            url: false,
            radio: true,
            noToggle: true,
            visible: true,
          },
        ],
      },
      {
        olType: "group",
        layerId: "kartdetaljer",
        title: "Detaljer",
        collapsible: true,
        groupCheckbox: false,
        altTarget: "fkb",
        layers: [
          {
            olType: "wmts",
            title: "Bygninger, veier, koter m.m.",
            layerId: "situasjon",
            url: parameters.cacheurl,
            layerName: "bakgrunn_linjer",
            altSource: {
              url: baseUrl + "/cgi-bin/wms?map=FORGRUNN",
              layerName: "Forgrunn",
              epsg: "EPSG:32632",
            },
            dependent: "tiltaksflate",
            noToggle: true,
            visible: true,
          },
          {
            olType: "image",
            title: "Gatenavn, adresser, m.m.",
            layerId: "text1",
            url: parameters.ki_forgrunnurl,
            layerName: "forgrunn_tekst",
            zIndex: 100,
            conditional: { condition: "flyfoto", trigger: "text2" },
            noToggle: true,
            default: true,
            displayInLayerMenu: true,
            visible: true,
          },
          {
            olType: "group",
            layerId: "eiendomsgrenser",
            title: "Eiendomsgrenser",
            collapsible: true,
            layerInfo: true,
            customLayerInfo:
              "<h3>Eiendomsgrenser</h3><br /><h4>Tegnforklaring:</h4><div class='legend-row'><div class='legend-symb legend-symb-line legend-eiendomsgrenser-landmaalt'>&nbsp;</div><div class='legend-text'>Eiendomsgrense</div></div><div class='legend-row'><div class='legend-symb legend-symb-line legend-seksjonsgrense'>&nbsp;</div><div class='legend-text'>Seksjonsgrense</div></div><div class='legend-row'><div class='legend-symb legend-anleggseiendommer'>&nbsp;</div><div class='legend-text'>Anleggseiendom</div></div><div class='legend-row'>",
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "wmts",
                title: "Eiendomsgrenser",
                layerId: "eiendom",
                layerInfo: false,
                url: parameters.cacheurl,
                layerName: "eiendom",
                altSource: {
                  url: parameters.kartinnsynurl,
                  layerName: "Eiendom_piv4",
                  epsg: "EPSG:32632",
                },
                visible: false,
              },
              {
                olType: "image",
                title: "Anleggseiendommer",
                layerId: "Anleggseiendom",
                layerInfo: false,
                url: parameters.kartinnsynurl,
                layerName: "Anleggseiendom",
                altSource: {
                  url: parameters.kartinnsynurl,
                  layerName: "Eiendom_piv5",
                  epsg: "EPSG:32632",
                },
                visible: false,
              },
            ],
          },
          {
            olType: "image",
            title: "Bydel",
            layerId: "bydel",
            url: parameters.kartinnsynurl,
            layerName: "Bydelsgrenser",
            visible: false,
          },
        ],
      },
    ],
    fkbLayers: false,
    quickSearch: true, //Legger til hurtigvalgsmeny på toppen av kartlagsmenyen. Modes under med displayname vises i nedtreksmenyen.
    modes: [
      { mode: "saksinnsyn", displayName: "Saksinnsyn", layers: ["byggesak"] },
      { mode: "kommuneplan", displayName: "Kommuneplan", layers: ["kp"] },
      { mode: "kpt1", layers: ["kp", "kp_pk1_2", "kp_tema_juridisk_stoy"] },
      {
        mode: "kpt2",
        layers: ["kp", "kp_pk1_2", "kp_tema_ikke_juridisk_luftforurensing_t2"],
      },
      {
        mode: "kpt3",
        layers: ["kp", "kp_pk1_2", "kp_tema_ikke_juridisk_luftforurensing_t3"],
      },
      {
        mode: "kpt4",
        layers: ["kp", "kp_pk1_2", "kp_tema_juridisk_naturmiljo"],
      },
      {
        mode: "kpt5",
        layers: ["kp", "kp_pk1_2", "kp_tema_ikke_juridisk_kulturminnevern"],
      },
      {
        mode: "kpt6",
        layers: ["kp", "kp_pk1_2", "kp_tema_juridisk_storulykke"],
      },
      {
        mode: "kpt7",
        layers: ["kp", "kp_pk1_2", "kp_tema_juridisk_blaagronn_struktur"],
      },
      { mode: "kp2-2", layers: ["kp", "kp_pk1_2", "kp_pk2_2"] },
      { mode: "gulliste", displayName: "Gul liste", layers: ["gulliste"] },
      { mode: "drenering", displayName: "Drenering", layers: ["drenering"] },
      {
        mode: "smahusplanen",
        displayName: "Småhusplanen",
        layers: ["smahusplanen"],
      },
      { mode: "vann", displayName: "Vann", layers: ["vann"] },
      { mode: "kdp", displayName: "Kommunedelplaner", layers: ["kdp"] },
      { mode: "eiendom", displayName: "Eiendom", layers: ["eiendom"] },
      {
        mode: "blagronn",
        displayName: "Blågrønn faktor",
        layers: ["blagronn_faktor", "eiendom"],
      },
      {
        mode: "planprogramogvpor",
        displayName: "Planprogram og vpor",
        layers: [
          "planprogram",
          "vpor",
          "vporpaagaaende",
          "planprogrampaagaaende",
        ],
      },
      { mode: "reklame", displayName: "Reklame", layers: ["reklameomrader"] },
      {
        mode: "mft",
        displayName: "Midlertidig forbud mot tiltak.",
        layers: ["MFT"],
      },
      {
        mode: "forurensetgrunn",
        displayName: "Forurenset grunn",
        layers: ["forurenset_grunn"],
      },
      {
        mode: "fortidsminner",
        displayName: "Sannsynlighet for å finne fortidsminner",
        layers: ["funnpotensiale"],
      },
      { mode: "veitype", displayName: "Veitype", layers: ["veitype"] },
      {
        mode: "autumn",
        handler: function () {
          var leafDiv = document.createElement("div");
          leafDiv.id = "leaves";
          for (var i = 0; i < 50; i++) {
            var leaf = document.createElement("i");
            leaf.className = "leaf";
            leafDiv.appendChild(leaf);
          }
          var map = $(document.body).contents();
          map.append(leafDiv);
          $(document.body).append(leafDiv);
        },
      },
      {
        mode: "winter",
        handler: function () {
          var snowDiv = document.createElement("div");
          snowDiv.id = "snowflakes";
          for (var i = 0; i < 50; i++) {
            var snowflake = document.createElement("i");
            snowflake.className = "snowflake";
            snowflake.innerHTML = "❆";
            snowDiv.appendChild(snowflake);
          }
          var map = $(document.body).contents();
          map.append(snowDiv);
          $(document.body).append(snowDiv);
        },
      },
      {
        mode: "christmas",
        handler: function () {
          var christmasDiv = document.createElement("div");
          christmasDiv.id = "snowflakes";
          var ornaments = [
            '<svg style="height: 50px;" version="1.1" id="sock_copy" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"><g><path fill="#E0E0E0" d="M63.7,97.7c-3.7,0-6.8-3-6.8-6.8V27.1c0-0.3,0-0.6,0.1-0.9c0,0,0,0,0,0c0,0,0.2-2.8-1.2-4.3c-1.3-1.4-3.9-2.4-5.8-2.4c-2.8,0-4.8,1.3-6,2.5c-1.6,1.8-1.5,4.9-1.5,4.9c0.4,3.7-2.4,7.1-6.1,7.4c-3.7,0.4-7.1-2.4-7.4-6.1c-0.1-0.9-0.7-9.1,4.9-15.4c2.6-2.9,7.5-6.3,16-6.3c8.7,0,13.5,3.5,16.1,6.4c4.8,5.5,4.6,12.4,4.5,14.5v63.5C70.5,94.7,67.4,97.7,63.7,97.7z"/></g><g><path fill="#E9646A" d="M29,28.2c0.1,1.1,0.5,2.1,1.1,3L54.6,7c-1.4-0.2-3-0.4-4.7-0.4c-2.5,0-4.6,0.3-6.5,0.8L29.6,21C28.7,24.7,28.9,27.7,29,28.2z"/><polygon fill="#E9646A" points="56.9,75.9 70.5,62.5 70.5,51.9 56.9,65.3 	"/><path fill="#E9646A" d="M56.9,90.9c0,2.4,1.2,4.5,3.1,5.7l10.5-10.4V75.6L56.9,89.1V90.9z"/><polygon fill="#E9646A" points="56.9,52.2 70.5,38.7 70.5,28.1 56.9,41.5 	"/><path fill="#E9646A" d="M55.8,21.9c1.4,1.6,1.2,4.3,1.2,4.3c0,0,0,0,0,0c0,0.3-0.1,0.6-0.1,0.9v1.3l11.7-11.6c-0.6-1.3-1.5-2.6-2.6-3.9c-0.6-0.7-1.3-1.4-2.2-2.1l-9.9,9.8C54.7,21,55.3,21.3,55.8,21.9z"/></g></svg>',
            '<svg style="height: 50px;" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"><rect display="none" fill="#468967" width="100" height="100"/><path fill="#E9656B" d="M41.1,16.1h44v58.6c0,0,3,22.9-22.9,22.9s-24.7,0-24.7,0s-23.1,1.1-23.1-16.2s17.9-16.7,21.8-16.7s5.2-1.7,5.2-7.8S41.1,16.1,41.1,16.1z"/><path fill="#DCDBDB" d="M40.2,7c0,0-6.8,0.3-6.8,6.8s7.7,6.5,7.7,6.5h44c0,0,5.5-0.6,5.5-6.7S83.2,7,83.2,7H40.2z"/><path fill="#C95964" d="M85.1,78.9c0,0-17.2-0.3-17.2,18.2l0,0C81.7,94.9,84.6,84.8,85.1,78.9z"/><path fill="#DCDBDB" d="M63.7,33.9h-0.6L62.4,33l-0.7,0.8h-0.6l1.3-1.7L63.7,33.9z M62.4,34.7l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L62.4,34.7z M62.4,37.5l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L62.4,37.5z M62.4,40.4l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L62.4,40.4zM62.4,43.5l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L62.4,43.5z M62.4,46l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L62.4,46z M62.4,48.8l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L62.4,48.8z M62.4,51.7l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L62.4,51.7z M66.6,51.7l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L66.6,51.7z M71.4,51.7l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L71.4,51.7z M76.5,51.7l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L76.5,51.7z M70.2,46.8l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L70.2,46.8z M74,47.1l-1.3,1.7h0.6L74,48l0.7,0.8h0.6L74,47.1z M70.7,42.6l-1.3,1.7H70l0.7-0.8l0.7,0.8H72L70.7,42.6z M66.6,42.6l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L66.6,42.6z M66.6,38.3L65.3,40h0.6l0.7-0.8l0.7,0.8h0.6L66.6,38.3z M57.4,53.3H58l0.7-0.8l0.7,0.8H60l-1.3-1.7L57.4,53.3z M52.6,53.3h0.6l0.7-0.8l0.7,0.8h0.6l-1.3-1.7L52.6,53.3z M47.5,53.3h0.6l0.7-0.8l0.7,0.8h0.6l-1.3-1.7L47.5,53.3z M53.9,48.5h0.6l0.7-0.8l0.7,0.8h0.6l-1.3-1.7L53.9,48.5z M50,48.8h0.6l0.7-0.8l0.7,0.8h0.6l-1.3-1.7L50,48.8z M53.3,44.3h0.6l0.7-0.8l0.7,0.8h0.6l-1.3-1.7L53.3,44.3zM57.4,44.3H58l0.7-0.8l0.7,0.8H60l-1.3-1.7L57.4,44.3z M57.4,40H58l0.7-0.8l0.7,0.8H60l-1.3-1.7L57.4,40z M61.9,55.1l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L61.9,55.1z M61.9,58l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L61.9,58z M63.2,55.1l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L63.2,55.1z M63.2,58l-1.3,1.7h0.6l0.7-0.8l0.7,0.8h0.6L63.2,58z"/></svg>',
            '<svg style="height: 50px;" version="1.1" id="leaves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"><path fill="#468967" d="M66,63.5c-0.1,0-0.9,0.1-2.1,0.5C52.2,65.4,40.2,46.7,40,47.1c3.6,10.4-18.8,14.3-19.5,14c3.2,9.4-11.7,22.4-11.7,22.4s19.5,0.4,22.7,9.8c0.3-0.7,20.4-11.4,24-1c0.4,0.2-1.7-21.7,8.2-27.9C65.1,63.9,65.9,63.5,66,63.5M53.1,67.9C37,75.9,18.7,79.7,18.7,79.7C23.8,78,53.1,67.8,53.1,67.9z"/><path fill="#468967" d="M63.2,66.6c0-0.1,0.2-0.9,0.3-2.2c3.2-11.3,25.1-15.2,24.8-15.5c-11-0.7-6-22.9-5.4-23.4C72.9,24.9,66.6,6.2,66.6,6.2s-7.8,17.9-17.7,17.3c0.5,0.5,2.7,23.2-8.3,22.5c-0.3,0.3,20.7,6.8,22.7,18.3C63.2,65.7,63.2,66.5,63.2,66.6 M64.1,53c-1.3-18,2.2-36.3,2.2-36.3C65.9,22.1,64.1,53,64.1,53z"/><circle fill="#C95964" cx="66.1" cy="62.3" r="4.5"/><ellipse transform="matrix(0.9869 -0.1616 0.1616 0.9869 -9.2629 11.3133)" fill="#E9656B" cx="64.9" cy="62.6" rx="1.5" ry="2.9"/><circle fill="#C95964" cx="60.4" cy="67" r="4.5"/><ellipse transform="matrix(0.9869 -0.1616 0.1616 0.9869 -10.1498 10.3594)" fill="#E9656B" cx="58.6" cy="67.6" rx="1.5" ry="2.9"/><circle fill="#C95964" cx="59.9" cy="60.7" r="4.5"/><ellipse transform="matrix(0.9869 -0.1616 0.1616 0.9869 -9.1538 10.1793)" fill="#E9656B" cx="58" cy="61.4" rx="1.5" ry="2.9"/></svg>',
          ];
          for (var i = 0; i < 11; i++) {
            var snowflake = document.createElement("i");
            snowflake.className = "snowflake";
            snowflake.innerHTML = ornaments[Math.ceil(Math.random() * 3) - 1];
            christmasDiv.appendChild(snowflake);
          }
          var map = $(document.body).contents();
          map.append(christmasDiv);
          $(document.body).append(christmasDiv);
        },
      },
    ],
    search: {
      autocompleteUrl: parameters.autocompleteUrl,
      autocompleteHandlers: [
        { key: "gate", func: "lookupAdresserForGate" },
        { key: "plan", func: "getLookupPlan" },
        { key: "stedsnavn", func: "getLookupStedsnavn" },
      ],
      ariaLabel:
        "Skriv inn adresse, gårds- og bruksnummer, plannummer eller saksnummer",
      placeholder: "Søk på adresse, gnr./bnr., plannr. eller saksnr.",
    },
    mapInteractions: {
      featureHover: true,
      featureClick: true,
    },
    contextMenu: {
      active: true,
      title1: "Om valgt eiendom",
      title2: "Om valgt punkt",
      mode: {
        top: true,
        area: true,
        point: true,
        bottom: "Hva vil du gjøre?",
      },
      headerField: {},
      bottomField: {},
      fields: [
        {
          id: "planerParent",
          title: "Planer",
          point: true,
          fields: [
            {
              id: "kommuneplan",
              title: "Kommuneplan",
              point: true,
            },
            {
              id: "kdp",
              title: "Kommunedelplan",
              point: true,
              featureCount: true,
            },
            {
              id: "omrreg",
              title: "Områderegulering",
              point: true,
              featureCount: true,
            },
            {
              id: "planer",
              title: "Reguleringsplaner",
              point: true,
              featureCount: true,
            },
            {
              id: "reklame",
              title: "Skilt- og reklameplan",
              point: true,
              featureCount: true,
            },
            {
              id: "torshov",
              title: "Torshovkvartalene",
              point: true,
              featureCount: true,
            },
            {
              id: "planprogram",
              title: "Planprogrammer",
              point: true,
              featureCount: true,
            },
            {
              id: "vpor",
              title: "VPOR",
              subTitle: "Veiledende plan for offentlig rom",
              point: true,
              featureCount: true,
            },
            {
              id: "hovinbyen",
              title: "Strategisk plan for Hovinbyen",
              point: true,
              featureCount: true,
            },
            {
              id: "tor",
              title: "TOR",
              point: true,
              featureCount: true,
            },
            {
              id: "kunngj",
              title: "Plankunngjøringer",
              point: true,
              featureCount: true,
            },
            {
              id: "mft",
              title: "Midlertidig forbud mot tiltak",
              point: true,
              featureCount: true,
            },
          ],
        },
        {
          id: "sakerParent",
          title: "Saker",
          subTitle: "Her finner du alle sakene på eiendommen",
          point: true,
          fields: [
            {
              id: "saker",
              title: "Byggesaker",
              point: false,
              featureCount: true,
            },
            {
              id: "plansaker",
              title: "Plansaker",
              point: false,
              featureCount: true,
            },
          ],
        },
        {
          id: "temakart",
          title: "Temakart",
          point: true,
          fields: [
            {
              id: "gulliste",
              title: "Gul liste",
              point: true,
              featureCount: true,
            },
            {
              id: "funnpot",
              title: "Fortidsminner",
              subTitle: "Sannsynlighet for funn",
              point: true,
              featureCount: true,
            },
            {
              id: "naturmangfold",
              title: "Naturmangfold",
              point: true,
              featureCount: true,
            },
            {
              id: "forurensetgrunn",
              title: "Forurenset grunn",
              point: true,
              featureCount: true,
            },
            {
              id: "vann",
              title: "Vann, bekker og elver",
              point: true,
              featureCount: true,
            },
            {
              id: "fjernvarme",
              title: "Konsesjonsområde for fjernvarme",
              point: true,
              featureCount: true,
            },
            {
              id: "maringrense",
              title: "Marin grense",
              point: true,
              featureCount: true,
            },
            {
              id: "veitype",
              title: "Veitype",
              point: true,
              featureCount: true,
            },
            {
              id: "fartsgrenser",
              title: "Fartsgrenser",
              point: true,
              featureCount: true,
            },
            {
              id: "trafikkmengde",
              title: "Trafikkmengde",
              point: true,
              featureCount: true,
            },
            {
              id: "blaagronn",
              title:
                "Blågrønn faktor <span class='layer-title-small'>(Norm for vegetasjon og vannhåndtering)</span>",
              point: true,
              featureCount: true,
            },
            {
              id: "friluftsliv",
              title: "Friluftslivsområder",
              point: true,
              featureCount: true,
            },
            {
              id: "overvann",
              title: "Overvann",
              point: true,
              featureCount: true,
            },
          ],
        },
      ],
      loaders: [
        {
          loaderType: "WFS",
          service: parameters.geoJsonWFS + parameters.wfsTillegg,
          typeNames: ["kpinfo_for_eiendom"],
          filterItem: ["teigid"],
          targets: [
            {
              id: "kommuneplan",
              layerId: "kp",
              showExtendedInfo: true,
              merInfoLink: "Mer info om kommuneplanen",
              merInfoLayout: [
                { type: "header", value: "Kommuneplan" },
                {
                  type: "paragraph",
                  value: "<strong>Arealplanid</strong><br />-",
                },
                {
                  type: "paragraph",
                  value: "<strong>Plantype</strong><br />Kommuneplan",
                },
                {
                  type: "paragraph",
                  value: "<strong>Planstatus</strong><br />Vedtatt",
                },
                {
                  type: "paragraph",
                  value:
                    "<strong>Planbestemmelse</strong><br />Se plandokument",
                },
                {
                  type: "paragraph",
                  value: "<strong>Lovreferanse</strong><br />PBL 2008",
                },
                {
                  type: "paragraph",
                  value: "<strong>Ikraftsettelsesdato</strong><br />23.09.2015",
                },
                {
                  type: "paragraph",
                  value:
                    "<strong>Plannavn</strong><br />Oslo mot 2030 – Smart, trygg og grønn",
                },
                {
                  type: "paragraph",
                  value:
                    "<strong>Vedtak endelig plandato</strong><br />23.09.2015",
                },
                {
                  type: "paragraph",
                  value: "<strong>Kunngjøringsdato</strong><br />23.09.2015",
                },
                {
                  type: "link",
                  url: "https://www.oslo.kommune.no/politikk/kommuneplan/",
                  text: "Kommuneplan - oversiktside",
                },
                {
                  type: "link",
                  url: "https://www.oslo.kommune.no/get-file/1125932/a5aa1fab56d1c7b655ddbb55331e12cbaec8293b30074db1d058f9ae898a1bd4",
                  text: "Plandokument - juridisk arealdel",
                },
                {
                  type: "link",
                  url: "https://einnsyn.no/moeteregistrering?id=http%3A%2F%2Fdata.einnsyn.no%2Fafb57a4f-1021-4073-b1f9-1f9ebdc29ed2",
                  text: "Vis sak i eInnsyn (innsyn i politiske saker)",
                },
              ],
              comparator: "header",
              sort: function (sort1, sort2) {
                if (sort1.get("TEMAGRUPPEKODE") > sort2.get("TEMAGRUPPEKODE"))
                  return 1;
                if (sort1.get("TEMAGRUPPEKODE") < sort2.get("TEMAGRUPPEKODE"))
                  return -1;
              },
              layout: [
                { type: "header", value: "header", unique: true },
                { type: "layerCheckbox", tekst: "Vis i kartet", unique: true },
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  labelValue: "{0}",
                  hover: true,
                  triggerField: true,
                },
              ],
              values: {
                legendValues: ["KODE"],
                labelValues: ["KODE_TEKST"],
                header: "TEMAGRUPPE",
                layerCheckbox: "TEMAGRUPPEKODE",
                comparator: "TEMAGRUPPE",
                counter: "KODE",
                key: "KODE",
              },
              extendedInfo: {
                header: "Kommuneplan",
                internal: "./kp_extended_info",
              },
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.planinnsynUrl,
          typeNames: ["Reg_eiendom", "Reg_eiendom_l"],
          filterItem: ["teigid"],
          targets: [
            {
              id: "kdp",
              filter: function (x) {
                return (
                  x.values_.PLANNAVN && x.values_.PLANNAVN.indexOf("KDP") >= 0
                );
              },
              layerCheckbox: true,
              layerId: "kdp",
              comparator: "header",
              counter: "navn",
              geometryType: true,
              layout: [
                {
                  type: "header",
                  value: "header",
                  triggerField: true,
                  unique: true,
                  halfling: true,
                },
                {
                  type: "itemCheckbox",
                  tekst: "Vis planområde",
                  unique: true,
                  url: parameters.kartinnsynurl + "&planid=",
                  urlKey: "id",
                  layer: "highlight_planid",
                },
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  labelValue: "{0}",
                  hover: true,
                  triggerField: false,
                },
              ],
              values: {
                id: "PLANID",
                legendValues: ["FORMAAL"],
                labelValues: ["FORMAAL"],
                header: "PLANNAVN",
                comparator: "PLANNAVN",
                layerCheckbox: "PLANNAVN",
                navn: "PLANNAVN",
                vertniv: "VERTNIV",
                dato: "IKRAFT",
                counter: "FORMAAL",
              },
              extendedInfo: {
                external: true,
                url: parameters.planmetaWSUrl + "plannavn=",
                urlKey: "navn",
                itemKey: "saksnr",
                header: "navn",
                layout: [
                  {
                    type: "paragraph",
                    prefix: "<strong>Saken gjelder</strong><br />",
                    value: "tittel",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Sakstype</strong><br />",
                    value: "typedef",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Vedtaksdato</strong><br />",
                    value: "vedtaksdato",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Vedtatt/behandlet av</strong><br />",
                    value: "instans",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong><strong>Lovverk</strong><br />",
                    value: "lovref",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Høydereferanse</strong><br />",
                    value: "href",
                    alt: "-",
                  },
                  //CONDITIONAL
                  {
                    type: "conditional",
                    condition: "vertniv",
                    1: { type: "paragraph", value: "Under bakken" },
                    2: { type: "paragraph", value: "På bakkenivå" },
                    3: { type: "paragraph", value: "Over bakken" },
                    4: { type: "paragraph", value: "På havbunnen" },
                    5: { type: "paragraph", value: "I vannsøylen" },
                  },
                  {
                    type: "conditional",
                    condition: "type",
                    //linkUrl = global.saksinnsynUrl + "showregbest.asp?planid=" + obj.id;
                    21: {
                      type: "link",
                      url: parameters.saksinnsynShowregbestUrl + "planid=",
                      urlParam: "id",
                      text: "Plandokument",
                    },
                    0: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "navn",
                      text: "Se plansak",
                    },
                    "": {
                      type: "link",
                      url: parameters.regbestIntranett + "%PARAM%/%PARAM%",
                      urlParam: ["vedtaksaar", "navn"],
                      postfix: ".pdf",
                      text: "Reguleringsbestemmelser",
                    },
                  },
                  {
                    type: "conditional",
                    condition: "dok",
                    0: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "saksnr",
                      text: "Vis plansak",
                    },
                    1: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "saksnr",
                      postfix: "&rplan=1",
                      text: "Vis saksdokumenter",
                    },
                  },
                  //{type: "link", url: parameters.saksinnsynCasedetUrl + "?caseno=", urlParam: "saksnr", text: "Vis saken i saksinnsyn"},
                  {
                    type: "multi",
                    value: "koblinger",
                    header: {
                      type: "paragraph",
                      value:
                        "<strong>Knytninger til andre planer</strong><br />",
                    },
                    layout: {
                      type: "div",
                      children: [
                        { type: "span", value: "type", postfix: ":" },
                        {
                          type: "button",
                          value: "navn",
                          classname: "btn btn-link",
                          clickfunction: function (
                            plannavn,
                            target,
                            privateFns,
                            config,
                          ) {
                            var url =
                              parameters.planmetaWSUrl + "plannavn=" + plannavn;
                            $.ajax({
                              url: url,
                              success: function (response) {
                                let contents = target.children().detach();
                                target.append(
                                  privateFns.createExtendedInfoSection(
                                    config.extendedInfo,
                                    config,
                                    response,
                                    contents,
                                    target,
                                  ),
                                );
                              },
                              fail: function () {
                                console.error("fail");
                              },
                              error: function () {
                                console.error("error");
                              },
                            });
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            {
              id: "omrreg",
              filter: function (x) {
                return x.values_.PLANTYPE === "34" || x.values_.PLANTYPE === 34;
              },
              layerCheckbox: true,
              layerId: "omrreg",
              merInfoLink: "Mer info om kommunedelplanen",
              comparator: "header",
              counter: "comparator",
              geometryType: true,
              layout: [
                {
                  type: "header",
                  value: "header",
                  altText:
                    "<strong>Objekter som ikke er tilknyttet en plan</strong>",
                  triggerField: true,
                  unique: true,
                },
                {
                  type: "conditional",
                  condition: "type",
                  unique: true,
                  130: {
                    type: "itemCheckbox",
                    tekst: "Vis planområde",
                    url: parameters.kartinnsynurl + "&planid=",
                    urlKey: "id",
                    layer: "highlight_planid_u_flate",
                  },
                  "": {
                    type: "itemCheckbox",
                    tekst: "Vis planområde",
                    url: parameters.kartinnsynurl + "&planid=",
                    urlKey: "id",
                    layer: "highlight_planid",
                  },
                },
                {
                  type: "link",
                  url: parameters.saksinnsynShowregbestUrl + "planid=",
                  urlParam: "id",
                  text: "Reguleringsbestemmelser",
                  unique: true,
                  addCondition: "dato",
                },
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "reg-",
                  labelValue: "{0}",
                  hover: true,
                  triggerField: false,
                },
              ],
              values: {
                id: "PLANID",
                legendValues: ["KODE"],
                labelValues: ["FORMAAL"],
                header: "PLANNAVN",
                layerCheckbox: "PLANNAVN",
                comparator: "PLANNAVN",
                counter: "FORMAAL",
                vertniv: "VERTNIV",
                dato: "IKRAFT",
                type: "PLANTYPE",
                navn: "PLANNAVN",
              },
              extendedInfo: {
                external: true,
                url: parameters.planmetaWSUrl + "plannavn=",
                urlKey: "navn",
                itemKey: "saksnr",
                header: "navn",
                layout: [
                  {
                    type: "paragraph",
                    prefix: "<strong>Saken gjelder</strong><br />",
                    value: "tittel",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Sakstype</strong><br />",
                    value: "typedef",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Vedtaksdato</strong><br />",
                    value: "vedtaksdato",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Vedtatt/behandlet av</strong><br />",
                    value: "instans",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong><strong>Lovverk</strong><br />",
                    value: "lovref",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Høydereferanse</strong><br />",
                    value: "href",
                    alt: "-",
                  },
                  //CONDITIONAL
                  {
                    type: "paragraph",
                    value: "<strong>Vertikalnivå</strong><br />",
                  },
                  {
                    type: "conditional",
                    condition: "vertniv",
                    1: { type: "paragraph", value: "Under bakken" },
                    2: { type: "paragraph", value: "På bakkenivå" },
                    3: { type: "paragraph", value: "Over bakken" },
                    4: { type: "paragraph", value: "På havbunnen" },
                    5: { type: "paragraph", value: "I vannsøylen" },
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Merknader</strong><br />",
                    value: "merknad",
                    alt: "-",
                  },
                  {
                    type: "conditional",
                    condition: "type",
                    21: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "navn",
                      text: "Plandokument",
                    },
                    0: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "navn",
                      text: "Se plansak",
                    },
                    "": {
                      type: "link",
                      url: parameters.regbestIntranett + "%PARAM%/%PARAM%",
                      urlParam: ["vedtaksaar", "navn"],
                      postfix: ".pdf",
                      text: "Reguleringsbestemmelser",
                    },
                  },
                  {
                    type: "conditional",
                    condition: "dok",
                    0: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "saksnr",
                      text: "Vis plansak",
                    },
                    1: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "saksnr",
                      postfix: "&rplan=1",
                      text: "Vis saksdokumenter",
                    },
                  },
                  //{type: "link", url: parameters.saksinnsynCasedetUrl + "?caseno=", urlParam: "saksnr", text: "Vis saken i saksinnsyn"},

                  {
                    type: "multi",
                    value: "koblinger",
                    header: {
                      type: "paragraph",
                      value:
                        "<strong>Knytninger til andre planer</strong><br />",
                    },
                    layout: {
                      type: "div",
                      children: [
                        { type: "span", value: "type", postfix: ":" },
                        {
                          type: "button",
                          value: "navn",
                          classname: "btn btn-link",
                          clickfunction: function (
                            plannavn,
                            target,
                            privateFns,
                            config,
                          ) {
                            var url =
                              parameters.planmetaWSUrl + "plannavn=" + plannavn;
                            $.ajax({
                              url: url,
                              success: function (response) {
                                let contents = target.children().detach();
                                target.append(
                                  privateFns.createExtendedInfoSection(
                                    config.extendedInfo,
                                    config,
                                    response,
                                    contents,
                                    target,
                                  ),
                                );
                              },
                              fail: function () {
                                console.error("fail");
                              },
                              error: function () {
                                console.error("error");
                              },
                            });
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            {
              id: "planer",
              filter: function (x) {
                return (
                  !(
                    x.values_.PLANNAVN && x.values_.PLANNAVN.indexOf("KDP") >= 0
                  ) && !(x.values_.FORMAAL === "Midlertidig forbud mot tiltak")
                );
              },
              layerCheckbox: true,
              layerId: "reg",
              merInfoLink: "Mer info om kommunedelplanen",
              comparator: "header",
              counter: "comparator",
              geometryType: true,
              layout: [
                {
                  type: "header",
                  value: "header",
                  altText:
                    "<strong>Objekter som ikke er tilknyttet en plan</strong>",
                  triggerField: true,
                  unique: true,
                  halfling: true,
                },
                {
                  type: "conditional",
                  condition: "type",
                  unique: true,
                  130: {
                    type: "itemCheckbox",
                    tekst: "Vis planområde",
                    url: parameters.kartinnsynurl + "&planid=",
                    urlKey: "id",
                    layer: "highlight_planid_u_flate",
                  },
                  "": {
                    type: "itemCheckbox",
                    tekst: "Vis planområde",
                    url: parameters.kartinnsynurl + "&planid=",
                    urlKey: "id",
                    layer: "highlight_planid",
                  },
                },
                {
                  type: "link",
                  url: parameters.saksinnsynShowregbestUrl + "planid=",
                  urlParam: "id",
                  text: "Reguleringsbestemmelser",
                  unique: true,
                  addCondition: "dato",
                },
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "reg-",
                  labelValue: "{0}",
                  hover: true,
                  triggerField: false,
                },
              ],
              values: {
                id: "PLANID",
                legendValues: ["KODE"],
                labelValues: ["FORMAAL"],
                header: "PLANNAVN",
                layerCheckbox: "PLANNAVN",
                comparator: "PLANNAVN",
                counter: "FORMAAL",
                vertniv: "VERTNIV",
                dato: "IKRAFT",
                type: "PLANTYPE",
                navn: "PLANNAVN",
              },
              extendedInfo: {
                external: true,
                url: parameters.planmetaWSUrl + "plannavn=",
                urlKey: "navn",
                itemKey: "saksnr",
                header: "navn",
                modify: function (plan) {
                  if (plan.dok && plan.dok > 1) {
                    plan.dok = 1;
                  }
                  return plan;
                },
                layout: [
                  {
                    type: "paragraph",
                    prefix: "<strong>Saken gjelder</strong><br />",
                    value: "tittel",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Sakstype</strong><br />",
                    value: "typedef",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Vedtaksdato</strong><br />",
                    value: "vedtaksdato",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Vedtatt/behandlet av</strong><br />",
                    value: "instans",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong><strong>Lovverk</strong><br />",
                    value: "lovref",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Høydereferanse</strong><br />",
                    value: "href",
                    alt: "-",
                  },
                  //CONDITIONAL
                  {
                    type: "paragraph",
                    value: "<strong>Vertikalnivå</strong><br />",
                  },
                  {
                    type: "conditional",
                    condition: "vertniv",
                    1: { type: "paragraph", value: "Under bakken" },
                    2: { type: "paragraph", value: "På bakkenivå" },
                    3: { type: "paragraph", value: "Over bakken" },
                    4: { type: "paragraph", value: "På havbunnen" },
                    5: { type: "paragraph", value: "I vannsøylen" },
                    "2,3,1": {
                      type: "paragraph",
                      value: "På bakkenivå, Over bakken, I Vannsøylen",
                    },
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Merknader</strong><br />",
                    value: "merknad",
                    alt: "-",
                  },
                  {
                    type: "conditional",
                    condition: "type",
                    "": {
                      type: "link",
                      url: parameters.saksinnsynShowregbestUrl + "planid=",
                      urlParam: "id",
                      text: "Reguleringsbestemmelser",
                      addCondition: "vedtaksdato",
                    },
                    0: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "navn",
                      text: "Se plansak",
                    },
                    21: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "navn",
                      text: "Plandokument",
                    },
                    30: {
                      type: "link",
                      url: parameters.saksinnsynShowregbestUrl + "planid=",
                      urlParam: "id",
                      text: "Reguleringsbestemmelser",
                      addCondition: "vedtaksdato",
                    },
                    35: {
                      type: "link",
                      url: parameters.saksinnsynShowregbestUrl + "planid=",
                      urlParam: "id",
                      text: "Reguleringsbestemmelser",
                      addCondition: "vedtaksdato",
                    },
                  },
                  {
                    type: "conditional",
                    condition: "dok",
                    0: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "saksnr",
                      text: "Vis plansak",
                    },
                    1: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "saksnr",
                      postfix: "&rplan=1",
                      text: "Vis saksdokumenter",
                    },
                    undefined: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "navn",
                      postfix: "&rplan=1",
                      text: "Vis saksdokumenter",
                    },
                  },
                  //{type: "link", url: parameters.saksinnsynCasedetUrl + "?caseno=", urlParam: "saksnr", text: "Vis saken i saksinnsyn"},

                  {
                    type: "multi",
                    value: "koblinger",
                    header: {
                      type: "paragraph",
                      value:
                        "<strong>Knytninger til andre planer</strong><br />",
                    },
                    layout: {
                      type: "div",
                      children: [
                        { type: "span", value: "type", postfix: ":" },
                        {
                          type: "button",
                          value: "navn",
                          classname: "btn btn-link",
                          clickfunction: function (
                            plannavn,
                            target,
                            privateFns,
                            config,
                          ) {
                            var url =
                              parameters.planmetaWSUrl + "plannavn=" + plannavn;
                            $.ajax({
                              url: url,
                              success: function (response) {
                                let contents = target.children().detach();
                                target.append(
                                  privateFns.createExtendedInfoSection(
                                    config.extendedInfo,
                                    config,
                                    response,
                                    contents,
                                    target,
                                  ),
                                );
                              },
                              fail: function () {
                                console.error("fail");
                              },
                              error: function () {
                                console.error("error");
                              },
                            });
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
            {
              id: "mft",
              filter: function (x) {
                return (
                  !(
                    x.values_.PLANNAVN && x.values_.PLANNAVN.indexOf("KDP") >= 0
                  ) && x.values_.FORMAAL === "Midlertidig forbud mot tiltak"
                );
              },
              point: true,
              layerCheckbox: true,
              layerId: "mft",
              comparator: "header",
              counter: "comparator",
              geometryType: true,
              layout: [
                {
                  type: "header",
                  value: "header",
                  altText:
                    "<strong>Objekter som ikke er tilknyttet en plan</strong>",
                  triggerField: true,
                  unique: true,
                  halfling: true,
                },
                {
                  type: "conditional",
                  condition: "type",
                  unique: true,
                  130: {
                    type: "itemCheckbox",
                    tekst: "Vis planområde",
                    url: parameters.kartinnsynurl + "&planid=",
                    urlKey: "id",
                    layer: "highlight_planid_u_flate",
                  },
                  "": {
                    type: "itemCheckbox",
                    tekst: "Vis planområde",
                    url: parameters.kartinnsynurl + "&planid=",
                    urlKey: "id",
                    layer: "highlight_planid",
                  },
                },
                {
                  type: "link",
                  url: parameters.regbestIntranett + "%PARAM%/%PARAM%",
                  urlParam: ["dato", "navn"],
                  postfix: ".pdf",
                  text: "Reguleringsbestemmelser",
                  unique: true,
                },
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "reg-",
                  labelValue: "{0}",
                  hover: true,
                  triggerField: false,
                },
              ],
              values: {
                id: "PLANID",
                legendValues: ["KODE"],
                labelValues: ["FORMAAL"],
                header: "PLANNAVN",
                layerCheckbox: "PLANNAVN",
                comparator: "PLANNAVN",
                counter: "FORMAAL",
                vertniv: "VERTNIV",
                dato: "IKRAFT",
                type: "PLANTYPE",
                navn: "PLANNAVN",
              },
              extendedInfo: {
                external: true,
                url: parameters.planmetaWSUrl + "plannavn=",
                urlKey: "navn",
                itemKey: "saksnr",
                header: "navn",
                layout: [
                  {
                    type: "paragraph",
                    prefix: "<strong>Saken gjelder</strong><br />",
                    value: "tittel",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Sakstype</strong><br />",
                    value: "typedef",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Vedtaksdato</strong><br />",
                    value: "vedtaksdato",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Vedtatt/behandlet av</strong><br />",
                    value: "instans",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong><strong>Lovverk</strong><br />",
                    value: "lovref",
                    alt: "-",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Høydereferanse</strong><br />",
                    value: "href",
                    alt: "-",
                  },
                  //CONDITIONAL
                  {
                    type: "paragraph",
                    value: "<strong>Vertikalnivå</strong><br />",
                  },
                  {
                    type: "conditional",
                    condition: "vertniv",
                    1: { type: "paragraph", value: "Under bakken" },
                    2: { type: "paragraph", value: "På bakkenivå" },
                    3: { type: "paragraph", value: "Over bakken" },
                    4: { type: "paragraph", value: "På havbunnen" },
                    5: { type: "paragraph", value: "I vannsøylen" },
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Merknader</strong><br />",
                    value: "merknad",
                    alt: "-",
                  },
                  {
                    type: "conditional",
                    condition: "type",
                    21: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "navn",
                      text: "Plandokument",
                    },
                    0: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "navn",
                      text: "Se plansak",
                    },
                    "": {
                      type: "link",
                      url: parameters.regbestIntranett + "%PARAM%/%PARAM%",
                      urlParam: ["vedtaksaar", "navn"],
                      postfix: ".pdf",
                      text: "Reguleringsbestemmelser",
                    },
                  },
                  {
                    type: "conditional",
                    condition: "dok",
                    0: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "saksnr",
                      text: "Vis plansak",
                    },
                    1: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "saksnr",
                      postfix: "&rplan=1",
                      text: "Vis saksdokumenter",
                    },
                    undefined: {
                      type: "link",
                      url: parameters.saksinnsynCasedetUrl + "?caseno=",
                      urlParam: "navn",
                      postfix: "&rplan=1",
                      text: "Vis saksdokumenter",
                    },
                  },
                  //{type: "link", url: parameters.saksinnsynCasedetUrl + "?caseno=", urlParam: "saksnr", text: "Vis saken i saksinnsyn"},

                  {
                    type: "multi",
                    value: "koblinger",
                    header: {
                      type: "paragraph",
                      value:
                        "<strong>Knytninger til andre planer</strong><br />",
                    },
                    layout: {
                      type: "div",
                      children: [
                        { type: "span", value: "type", postfix: ":" },
                        {
                          type: "button",
                          value: "navn",
                          classname: "btn btn-link",
                          clickfunction: function (
                            plannavn,
                            target,
                            privateFns,
                            config,
                          ) {
                            var url =
                              parameters.planmetaWSUrl + "plannavn=" + plannavn;
                            $.ajax({
                              url: url,
                              success: function (response) {
                                let contents = target.children().detach();
                                target.append(
                                  privateFns.createExtendedInfoSection(
                                    config.extendedInfo,
                                    config,
                                    response,
                                    contents,
                                    target,
                                  ),
                                );
                              },
                              fail: function () {
                                console.error("fail");
                              },
                              error: function () {
                                console.error("error");
                              },
                            });
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.reklameurl,
          typeNames: ["reklame_for_eiendom", "reklame_for_eiendom_l"],
          filterItem: ["teigid"],
          targets: [
            {
              id: "reklame",
              layerCheckbox: true,
              layerId: "reklameomrader",
              counter: "counter",
              layout: [
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "reklame-",
                  labelValue: "{0}",
                  hover: true,
                  triggerField: true,
                },
              ],
              values: {
                legendValues: ["OBJTYPE"],
                labelValues: ["LABEL"],
                comparator: "OBJTYPE",
                triggerField: "OBJTYPE",
                counter: "OBJTYPE",
              },
              //Conditional sier hva som skal sammenliknes med condition
              extendedInfo: {
                header: "Skilt og reklameplan",
                layout: [
                  {
                    type: "conditional",
                    condition: "comparator",
                    XS_Omrader: [
                      {
                        type: "header",
                        value: "Reklameområde XS (sårbare områder):",
                      },
                      {
                        type: "paragraph",
                        value:
                          "Områder med lite næringsaktivitet, høy sårbarhet og prioritering av aktiviteter for fellesskapet. Reklameområde XS skal ikke ha reklame, bortsett fra det som tillates i retningslinjenes pkt. 7.1.",
                      },
                      {
                        type: "link",
                        url: "https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=50",
                        text: "Se retningslinjenes punkt 7.1 i Skilt- reklameplanen for Oslo.",
                      },
                    ],
                    S_Omrader: [
                      {
                        type: "header",
                        value: "Reklameområde S (boligdominerte områder):",
                      },
                      {
                        type: "paragraph",
                        value:
                          "Områder hvor det i hovedsak er boliger, og der det er lite til middels næringsaktivitet. I reklameområde S skal stedlige virksomheter kunne eksponere seg med skilt og mindre reklame – så lenge det ikke sjenerer de som bor der i særlig stor grad. Med reklame for stedlig virksomhet menes reklame som gjelder den virksomheten som holder til i bygningen/eiendommen hvor reklamen plasseres.",
                      },
                      {
                        type: "link",
                        url: "https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=50",
                        text: "Se retningslinjenes punkt 7.2 i Skilt- reklameplanen for Oslo.",
                      },
                    ],
                    M_Omrader: [
                      {
                        type: "header",
                        value:
                          "Reklameområde M (områder med blandede funksjoner):",
                      },
                      {
                        type: "paragraph",
                        value:
                          "Områder med middels til høy næringsaktivitet og med færre boliger. I reklameområde M skal skilt og reklame speile variasjonen i området.",
                      },
                      {
                        type: "link",
                        url: "https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=51",
                        text: "Se retningslinjenes punkt 7.3 i Skilt- reklameplanen for Oslo.",
                      },
                    ],
                    M_Omrade_Hovedgate: [
                      {
                        type: "header",
                        value:
                          "Reklameområde M (områder med blandede funksjoner):",
                      },
                      {
                        type: "paragraph",
                        value:
                          "Områder med middels til høy næringsaktivitet og med færre boliger. I reklameområde M skal skilt og reklame speile variasjonen i området.",
                      },
                      {
                        type: "link",
                        url: "https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=51",
                        text: "Se retningslinjenes punkt 7.3 i Skilt- reklameplanen for Oslo.",
                      },
                    ],
                    L_Omrader: [
                      {
                        type: "header",
                        value: "Reklameområde L (næringsdominerte områder):",
                      },
                      {
                        type: "paragraph",
                        value:
                          "Områder med høy næringsaktivitet inkludert næringsområder med estetisk og historisk betydning, og arenaer for idrett og rekreasjon. I reklameområde L skal næringsvirksomheter kunne eksponeres tydelig.",
                      },
                      {
                        type: "link",
                        url: "https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=52",
                        text: "Se retningslinjenes punkt 7.4 i Skilt- reklameplanen for Oslo.",
                      },
                    ],
                    L_Omrade_Stroksgate: [
                      {
                        type: "header",
                        value: "Reklameområde L (næringsdominerte områder):",
                      },
                      {
                        type: "paragraph",
                        value:
                          "Områder med høy næringsaktivitet inkludert næringsområder med estetisk og historisk betydning, og arenaer for idrett og rekreasjon. I reklameområde L skal næringsvirksomheter kunne eksponeres tydelig.",
                      },
                      {
                        type: "link",
                        url: "https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=52",
                        text: "Se retningslinjenes punkt 7.4 i Skilt- reklameplanen for Oslo.",
                      },
                    ],
                    L_Omrade_Riksvei: [
                      {
                        type: "header",
                        value: "Reklameområde L (næringsdominerte områder):",
                      },
                      {
                        type: "paragraph",
                        value:
                          "Områder med høy næringsaktivitet inkludert næringsområder med estetisk og historisk betydning, og arenaer for idrett og rekreasjon. I reklameområde L skal næringsvirksomheter kunne eksponeres tydelig.",
                      },
                      {
                        type: "link",
                        url: "https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=52",
                        text: "Se retningslinjenes punkt 7.4 i Skilt- reklameplanen for Oslo.",
                      },
                    ],
                    L_Omrade_Symbol: [
                      { type: "header", value: "Tett by" },
                      {
                        type: "paragraph",
                        value:
                          "Områder med høy næringsaktivitet inkludert næringsområder med estetisk og historisk betydning, og arenaer for idrett og rekreasjon. I reklameområde L skal næringsvirksomheter kunne eksponeres tydelig.",
                      },
                      {
                        type: "link",
                        url: "https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=52",
                        text: "Se retningslinjenes punkt 7.4 i Skilt- reklameplanen for Oslo.",
                      },
                    ],
                  },
                  {
                    type: "header",
                    value:
                      "Generelle retningslinjer for skilt- og reklame i Oslo",
                  },
                  { type: "paragraph", value: "Gjelder for hele Oslo." },
                  {
                    type: "link",
                    url: "https://www.oslo.kommune.no/get-file/111660/477250f98dfa905a601f43f9c916973c1d9354c8334d7c84f063eb41982a05e4#page=48",
                    text: "Se retningslinjenes punkt 6.1-6.28 i Skilt- reklameplanen for Oslo.",
                  },
                ],
              },
            },
          ],
        },
        {
          //TORSHOV
          table: "kart.torshovkvartalene",
          loaderType: "WFS",
          service: parameters.tableWfs + "kart.torshovkvartalene",
          typeNames: ["eiendom_polygon", "eiendom_linje"],
          filterItem: ["teigid"],
          targets: [
            {
              id: "torshov",
              layerCheckbox: true,
              layerId: "torshovkvartalene",
              counter: "counter",
              layout: [
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "torshov-",
                  labelPrefix: "Kvartal ",
                  labelValue: "Kategori {0}: {1} (kvartal {2})",
                  hover: true,
                },
                {
                  type: "link",
                  url: "https://www.oslo.kommune.no/get-file/282498/7b62aed2a2ad193fef94f2ef43f8b25f6f96d8f7128831bfde3ef2b2e2911ef9#page=",
                  urlParam: "side",
                  text: "Se veileder",
                },
                {
                  type: "link",
                  url: "https://lovdata.no/dokument/LF/forskrift/2001-10-17-1444",
                  text: "Se forskrift",
                },
              ],
              values: {
                legendValues: ["KATEGORI"],
                labelValues: ["KATEGORI", "KV_BESKRIV", "KVARTAL"],
                comparator: "KVARTAL",
                triggerField: "KVARTAL",
                counter: "KVARTAL",
                side: "VEILEDERS",
              },
              showExtendedInfo: false,
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.tableWfs + "vpor_planprogram&type=planprogram",
          table: "vpor_planprogram",
          typeNames: ["eiendom_polygon", "eiendom_linje"],
          filterItem: ["teigid"],
          targets: [
            {
              id: "planprogram",
              filter: function (x) {
                return x.values_.TYPE === "planprogram";
              },
              layerCheckbox: true,
              layerId: "planprogram",
              triggerField: "navn",
              counter: "counter",
              showExtendedInfo: true,
              layout: [
                {
                  type: "header",
                  value: "triggerField",
                  triggerField: true,
                  unique: true,
                },
                { type: "paragraph", value: "subfields" },
              ],
              values: {
                triggerField: "NAVN",
                subfields: ["UNDERTEKST"],
                counter: "NAVN",
                navn: "NAVN",
                beskrivelse: "BESKRIVELSE",
                doklenke: "DOKLENKE",
                saksnr: "SAKSNR",
              },
              showExtendedInfo: true,
              extendedInfo: {
                header: "Planprogram",
                layout: [
                  { type: "header", value: "NAVN" },
                  { type: "paragraph", value: "BESKRIVELSE" },
                  { type: "header", value: "UNDERTEKST" },
                  {
                    type: "link",
                    href: "DOKLENKE",
                    text: "DOKLENKETEKST",
                    addCondition: "DOKLENKE",
                  },
                  {
                    type: "link",
                    url: parameters.saksinnsynCasedetUrl + "?caseno=",
                    urlParam: "SAKSNR",
                    text: "Vis saksdokumenter",
                  },
                ],
              },
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.tableWfs + "vpor_planprogram&type=vpor",
          table: "vpor_planprogram",
          typeNames: ["eiendom_polygon", "eiendom_linje"], //Brukes til WFS URL
          filterItem: ["teigid"],
          targets: [
            {
              id: "vpor",
              filter: function (x) {
                return x.values_.TYPE === "vpor";
              },
              point: true,
              layerCheckbox: true,
              layerId: "vpor",
              counter: "counter",
              layout: [
                { type: "header", value: "triggerField", triggerField: true },
                { type: "paragraph", value: "subfields" },
              ],
              values: {
                triggerField: "NAVN",
                subfields: ["UNDERTEKST"],
                counter: "NAVN",
                navn: "NAVN",
                beskrivelse: "BESKRIVELSE",
                doklenke: "DOKLENKE",
                saksnr: "SAKSNR",
              },
              extendedInfo: {
                header: "VPOR",
                layout: [
                  { type: "header", value: "NAVN" },
                  { type: "paragraph", value: "BESKRIVELSE" },
                  { type: "header", value: "UNDERTEKST" },
                  {
                    type: "link",
                    href: "DOKLENKE",
                    text: "DOKLENKETEKST",
                    addCondition: "DOKLENKE",
                  },
                  {
                    type: "link",
                    url: parameters.saksinnsynCasedetUrl + "?caseno=",
                    urlParam: "SAKSNR",
                    text: "Vis saksdokumenter",
                  },
                ],
              },
            },
          ],
        },

        {
          //TOR
          loaderType: "WFS",
          service: parameters.tableWfs + "vpor_planprogram&type=tor",
          table: "vpor_planprogram",
          typeNames: ["eiendom_polygon", "eiendom_linje"], //Brukes til WFS URL
          filterItem: ["teigid"],
          targets: [
            {
              id: "tor",
              filter: function (x) {
                return x.values_.TYPE === "tor";
              },
              point: true,
              layerCheckbox: true,
              layerId: "tor",
              counter: "counter",
              layout: [
                { type: "header", value: "triggerField", triggerField: true },
                { type: "paragraph", value: "subfields" },
              ],
              values: {
                triggerField: "NAVN",
                subfields: ["UNDERTEKST"],
                counter: "NAVN",
                navn: "NAVN",
                beskrivelse: "BESKRIVELSE",
                doklenke: "DOKLENKE",
                saksnr: "SAKSNR",
              },
              extendedInfo: {
                header: "TOR",
                layout: [
                  { type: "header", value: "NAVN" },
                  { type: "paragraph", value: "BESKRIVELSE" },
                  { type: "header", value: "UNDERTEKST" },
                  {
                    type: "link",
                    href: "DOKLENKE",
                    text: "DOKLENKETEKST",
                    addCondition: "DOKLENKE",
                  },
                  {
                    type: "link",
                    url: parameters.saksinnsynCasedetUrl + "?caseno=",
                    urlParam: "SAKSNR",
                    text: "Vis saksdokumenter",
                  },
                ],
              },
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.tableWfs + "vpor_planprogram&type=hovin",
          table: "vpor_planprogram",
          typeNames: ["eiendom_polygon", "eiendom_linje"], //Brukes til WFS URL
          filterItem: ["teigid"],
          targets: [
            {
              id: "hovinbyen",
              filter: function (x) {
                return x.values_.TYPE === "hovin";
              },
              point: true,
              layerCheckbox: true,
              layerId: "hovinbyen",
              counter: "counter",
              layout: [
                { type: "header", value: "triggerField", triggerField: true },
                { type: "paragraph", value: "subfields" },
              ],
              values: {
                triggerField: "NAVN",
                subfields: ["UNDERTEKST"],
                counter: "NAVN",
                navn: "NAVN",
                beskrivelse: "BESKRIVELSE",
                doklenke: "DOKLENKE",
                saksnr: "SAKSNR",
              },
              extendedInfo: {
                header: "Strategisk plan for Hovinbyen",
                layout: [
                  { type: "header", value: "NAVN" },
                  { type: "paragraph", value: "BESKRIVELSE" },
                  {
                    type: "link",
                    href: "DOKLENKE",
                    text: "DOKLENKETEKST",
                    addCondition: "DOKLENKE",
                  },
                  {
                    type: "link",
                    url: parameters.saksinnsynCasedetUrl + "?caseno=",
                    urlParam: "SAKSNR",
                    text: "Vis saksdokumenter",
                  },
                ],
              },
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.geoJsonWFS + parameters.wfsTillegg,
          typeNames: ["kunngj_for_eiendom"],
          filterItem: ["teigid"],
          targets: [
            {
              id: "kunngj",
              point: true,
              layerCheckbox: true,
              layerId: "kunngjoringer",
              counter: "header",
              layout: [
                { type: "header", value: "header" },
                { type: "paragraph", value: "B1", strong: true },
                { type: "paragraph", value: "B2" },
                { type: "paragraph", value: "B3", strong: true },
                { type: "paragraph", value: "B4" },
                {
                  type: "link",
                  url: parameters.sidinmeningUrl + "?caseno=",
                  urlParam: "id",
                  text: "Vis kunngjøringen og si din mening ",
                },
              ],
              values: {
                header: "T",
                B1: "B1",
                B2: "B2",
                B3: "B3",
                B4: "B4",
                subfields: ["T1"],
                id: "ID",
              },
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.kartinnsynurl + parameters.wfsTillegg,
          typeNames: ["byggesak_for_eiendom"],
          filterItem: ["gnr", "bnr"],
          targets: [
            {
              id: "saker",
              counter: "feature",
              maxSubFields: 3,
              showAllText: "Vis alle byggesaker",
              layout: [
                { type: "paragraph", value: "tittel" },
                {
                  type: "conditional",
                  condition: "avsluttet",
                  A: { type: "paragraph", value: "Avsluttet" },
                  B: { type: "paragraph", value: "SISTEDOKDATO" },
                },
                { type: "paragraph", value: "Saksnr:", strong: true },
                { type: "paragraph", value: "saksnr" },
                {
                  type: "link",
                  url: parameters.saksinnsynCasedetUrl + "?caseno=",
                  urlParam: "saksnr",
                  text: "Vis saken i saksinnsyn",
                },
              ],
              values: {
                tittel: "TITTEL",
                saksnr: "SAKSNR",
                avsluttet: "SAKAVSLUTTET",
                //Funksjonen returnerer bearbeidet dato, input er verdien som hentes fra wfs her SISTEDOKDATO case sensitiv.
                SISTEDOKDATO: function (dato) {
                  let current_datetime = new Date(dato);
                  return (
                    "Siste dok. " +
                    current_datetime.getDate() +
                    "." +
                    (current_datetime.getMonth() + 1) +
                    "." +
                    current_datetime.getFullYear()
                  );
                },
                sistedok: "SISTEDOK",
                header: "T",
                B1: "B1",
                B2: "B2",
                subfields: ["T1"],
                id: "id",
              },
              showExtendedInfo: true,
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.kartinnsynurl + parameters.wfsTillegg,
          typeNames: ["plansak_for_eiendom"],
          filterItem: ["gnr", "bnr"],
          targets: [
            {
              id: "plansaker",
              counter: "tittel",
              maxSubFields: 3,
              showAllText: "Vis alle plansaker",
              layout: [
                { type: "paragraph", value: "tittel" },
                {
                  type: "conditional",
                  condition: "avsluttet",
                  A: { type: "paragraph", value: "Avsluttet" },
                  B: { type: "paragraph", value: "SISTEDOKDATO" },
                },
                { type: "paragraph", value: "Saksnr:", strong: true },
                { type: "paragraph", value: "saksnr" },
                {
                  type: "link",
                  url: parameters.saksinnsynCasedetUrl + "?caseno=",
                  urlParam: "saksnr",
                  text: "Vis saken i saksinnsyn",
                },
              ],
              values: {
                tittel: "TITTEL",
                saksnr: "SAKSNR",
                avsluttet: "SAKAVSLUTTET",
                //Funksjonen returnerer bearbeidet dato, input er verdien som hentes fra wfs her SISTEDOKDATO case sensitiv.
                SISTEDOKDATO: function (dato) {
                  let current_datetime = new Date(dato);
                  return (
                    "Siste dok. " +
                    current_datetime.getDate() +
                    "." +
                    (current_datetime.getMonth() + 1) +
                    "." +
                    current_datetime.getFullYear()
                  );
                },
                sistedok: "SISTEDOK",
              },
              showExtendedInfo: true,
              subFields: [
                { value: "tittel" },
                { value: "type", strong: true },
                { value: "plantype" },
                { value: "hoering_til_tekst", strong: true },
                { value: "til_dato_tekst" },
              ],
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.tableWfs + "gulliste_spatial",
          table: "gulliste_spatial",
          typeNames: ["eiendom_polygon", "eiendom_linje"], //Brukes til WFS URL
          filterItem: ["teigid"],
          targets: [
            {
              id: "gulliste",
              showExtendedInfo: true,
              showAsLegend: true,
              layerCheckbox: true,
              layerId: "gulliste",
              counter: "feature",
              comparator: "comparator",
              layout: [
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  labelValue: "{0}",
                  counter: "counter",
                  triggerField: true,
                  hover: true,
                },
              ],
              values: {
                legendValues: ["TYPE", "VERNKODE"],
                labelValues: ["TYPE", "MAPPING"],
                counter: "TYPE",
                comparator: "TYPE",
                triggerField: "MAPPING",
                navn: "NAVN",
                dato: "KOPIDATO",
                kat: "KATEGORI",
                vern: "VERN",
                regav: "REGAV",
                gid: "GL_ID",
              },
              extendedInfo: {
                hover: true,
                layout: [
                  {
                    type: "paragraph",
                    prefix: "<strong>Navn</strong><br />",
                    value: "NAVN",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Oppdatert</strong><br />",
                    value: "KOPIDATO",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Kategori</strong><br />",
                    value: "KATEGORI",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Vern</strong><br />",
                    value: "VERN",
                  },
                  {
                    type: "paragraph",
                    prefix: "<strong>Registrert av</strong><br />",
                    value: "REGAV",
                  },
                  {
                    type: "link",
                    href: "LINKKULTURMINNESOK",
                    text: "Kulturminnesøk",
                  },
                ],
              },
            },
          ],
        },
        {
          //FUNNPOTENSIALE FORTIDSMINNER
          loaderType: "WFS",
          service: parameters.tableWfs + "kart.funnpotensial",
          typeNames: ["eiendom_polygon", "eiendom_linje", "eiendom_punkt"],
          table: "kart.funnpotensial",
          filterItem: ["teigid"],
          targets: [
            {
              id: "funnpot",
              layerCheckbox: true,
              layerId: "funnpotensiale",
              counter: "beskrivelse",
              layout: [
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "funnpotensiale-",
                  labelValue: "{0}",
                  hover: true,
                },
              ],
              values: {
                legendValues: ["KATEGORI"],
                labelValues: ["BESKRIVELSE"],
                beskrivelse: "BESKRIVELSE",
              },
              showExtendedInfo: true,
            },
          ],
        },
        {
          //NATURMANGFOLD
          loaderType: "WFS",
          service: parameters.tableWfs + "naturmangfold",
          table: "naturmangfold",
          typeNames: ["eiendom_polygon", "eiendom_linje", "eiendom_punkt"], //Brukes til WFS URL
          filterItem: ["teigid"],
          targets: [
            {
              id: "naturmangfold",
              layerCheckbox: true,
              layerId: "naturmangfold",
              counter: "beskrivelse",
              comparator: "comparator",
              layout: [
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "naturmangfold-",
                  labelValue: "{0}",
                  unique: false,
                  hover: true,
                },
                {
                  type: "link",
                  url: "url",
                  text: "Faktaark",
                  addCondition: "url",
                },
              ],
              values: {
                legendValues: ["NATURFORHOLD"],
                labelValues: ["TEMANAVN"],
                beskrivelse: "TEMANAVN",
                comparator: "TYPE",
                url: "FAKTAARK",
              },
              showExtendedInfo: false,
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.tableWfs + "grunnforurensning",
          table: "grunnforurensning",
          typeNames: ["eiendom_polygon", "eiendom_linje", "eiendom_punkt"], //Brukes til WFS URL
          filterItem: ["teigid"],
          targets: [
            {
              id: "forurensetgrunn",
              layerCheckbox: true,
              layerId: "forurenset_grunn",
              counter: "beskrivelse",
              comparator: "comparator",
              layout: [
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "forurenset_grunn-",
                  labelValue: "{0}",
                  unique: true,
                  hover: true,
                },
                { type: "link", url: "url", text: "navn", addCondition: "url" },
              ],
              values: {
                legendValues: ["TEMANAVN"],
                labelValues: ["KODE_TEKST"],
                beskrivelse: "TEMANAVN",
                comparator: "TEMANAVN",
                url: "FAKTAARK",
                navn: ["NAVN"],
              },
              showExtendedInfo: false,
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.tableWfs + "t_vd_historiske_elvelop",
          table: "t_vd_historiske_elvelop",
          typeNames: ["eiendom_polygon", "eiendom_linje", "eiendom_punkt"], //Brukes til WFS URL
          filterItem: ["teigid"],
          targets: [
            {
              id: "vann",
              filter: function (x) {
                return x.values_.KODE_TEKST;
              },
              layerCheckbox: true,
              layerId: "vann",
              counter: "beskrivelse",
              comparator: "comparator",
              layout: [
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "vann-",
                  labelValue: "{0}",
                  unique: true,
                  hover: true,
                },
              ],
              values: {
                legendValues: ["KODE"],
                labelValues: ["KODE_TEKST"],
                beskrivelse: "KODE_TEKST",
                comparator: "KODE",
              },
              showExtendedInfo: false,
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.tableWfs + "q_vann",
          table: "q_vann",
          typeNames: ["eiendom_polygon", "eiendom_linje", "eiendom_punkt"], //Brukes til WFS URL
          filterItem: ["teigid"],
          targets: [
            {
              id: "vann",
              filter: function (x) {
                return x.values_.KODE_TEKST;
              },
              layerCheckbox: true,
              layerId: "vann",
              counter: "beskrivelse",
              comparator: "comparator",
              layout: [
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "vann-",
                  labelValue: "{0}",
                  unique: true,
                  hover: true,
                },
              ],
              values: {
                legendValues: ["KODE"],
                labelValues: ["KODE_TEKST"],
                beskrivelse: "KODE_TEKST",
                comparator: "KODE",
              },
              showExtendedInfo: false,
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.tableWfs + "kart.fjernvarmekonsesjon",
          table: "kart.fjernvarmekonsesjon",
          typeNames: ["eiendom_polygon", "eiendom_linje"], //Brukes til WFS URL
          filterItem: ["teigid"],
          targets: [
            {
              id: "fjernvarme",
              layerCheckbox: true,
              layerId: "fjernvarme",
              counter: "beskrivelse",
              comparator: "comparator",
              modify: function (features) {
                features.forEach(function (feature, index, arr) {
                  var string = feature.values_.NAVN;
                  var length = string.length - 1;
                  feature.values_.NAVN =
                    string.charAt(0) + string.toLowerCase().slice(-length);
                  arr[index] = feature;
                });
                return features;
              },
              layout: [
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "fjernvarme-",
                  labelValue: "{0}",
                  unique: true,
                  hover: true,
                },
              ],
              values: {
                legendValues: ["TEMAKODE"],
                labelValues: ["NAVN"],
                beskrivelse: "TEMAKODE",
                comparator: "TEMAKODE",
              },
              showExtendedInfo: false,
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.tableWfs + "vd_maringrense",
          table: "vd_maringrense",
          typeNames: ["eiendom_polygon", "eiendom_linje"], //Brukes til WFS URL
          filterItem: ["teigid"],
          targets: [
            {
              id: "maringrense",
              layerCheckbox: true,
              layerId: "maringrense",
              counter: "beskrivelse",
              comparator: "comparator",
              modify: function (features) {
                features.forEach(function (feature, index, arr) {
                  var string = feature.values_.OBJTYPE;
                  var length = string.length - 1;
                  feature.values_.OBJTYPE =
                    string.charAt(0) + string.toLowerCase().slice(-length);
                  arr[index] = feature;
                });
                return features;
              },
              layout: [
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  labelValue: "{0}",
                  unique: true,
                  hover: true,
                },
              ],
              values: {
                legendValues: ["OBJTYPE"],
                labelValues: ["OBJTYPE"],
                beskrivelse: "OBJTYPE",
                comparator: "OBJTYPE",
              },
              showExtendedInfo: false,
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.tableWfs + "kart.fartsgrense",
          table: "kart.fartsgrense",
          typeNames: ["eiendom_polygon", "eiendom_linje"], //Brukes til WFS URL
          filterItem: ["teigid"],
          targets: [
            {
              id: "veitype",
              filter: function (x) {
                return x.values_.VEGKATEGORI;
              },
              layerCheckbox: true,
              layerId: "veitype",
              counter: "beskrivelse",
              comparator: "comparator",
              layout: [
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "vegkategori-",
                  labelValue: "{0}",
                  unique: true,
                  hover: true,
                },
              ],
              values: {
                legendValues: ["VEGKATEGORI"],
                labelValues: ["VEGKATEGORI"],
                beskrivelse: "VEGKATEGORI",
                comparator: "VEGKATEGORI",
              },
              showExtendedInfo: false,
            },
            {
              id: "fartsgrenser",
              layerCheckbox: true,
              layerId: "fartsgrenser",
              filter: function (x) {
                return x.values_.FARTSGRENSEVERDI;
              },
              counter: "beskrivelse",
              comparator: "comparator",
              layout: [
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "fartsgrense",
                  labelValue: "{0}",
                  labelClass: "fartsgrense-label",
                  unique: true,
                  hover: true,
                },
              ],
              values: {
                legendValues: [""],
                labelValues: ["FARTSGRENSEVERDI"],
                beskrivelse: "FARTSGRENSEVERDI",
                comparator: "FARTSGRENSEVERDI",
              },
              showExtendedInfo: false,
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.tableWfs + "aadt",
          table: "aadt",
          typeNames: ["eiendom_polygon", "eiendom_linje"], //Brukes til WFS URL
          filterItem: ["teigid"],
          targets: [
            {
              id: "trafikkmengde",
              layerCheckbox: true,
              layerId: "trafikkmengde",
              modify: function (features) {
                features.forEach(function (feature, index, arr) {
                  var tot = feature.values_.AADT_TOTAL;
                  if (tot < 500) {
                    feature.values_.AADT_TOTAL_MOD = 499;
                  } else if (500 <= tot && tot < 2000) {
                    feature.values_.AADT_TOTAL_MOD = 500;
                  } else if (2000 <= tot && tot < 5000) {
                    feature.values_.AADT_TOTAL_MOD = 2000;
                  } else if (5000 <= tot && tot < 10000) {
                    feature.values_.AADT_TOTAL_MOD = 5000;
                  } else {
                    feature.values_.AADT_TOTAL_MOD = 10000;
                  }
                  arr[index] = feature;
                });
                return features;
              },
              counter: "feature",
              comparator: "comparator",
              layout: [
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "aadt-",
                  labelValue: "{0}",
                  labelSuffix: " ÅDT",
                  hover: true,
                },
              ],
              values: {
                legendValues: ["AADT_TOTAL_MOD"],
                labelValues: ["AADT_TOTAL"],
                comparator: "AADT_TOTAL_MOD",
              },
              showExtendedInfo: false,
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.tableWfs + "regis.blaagronnfaktor",
          table: "regis.blaagronnfaktor",
          typeNames: ["eiendom_polygon", "eiendom_linje"], //Brukes til WFS URL
          filterItem: ["teigid"],
          targets: [
            {
              id: "blaagronn",
              layerCheckbox: true,
              layerId: "blagronn_faktor",
              counter: "beskrivelse",
              comparator: "comparator",
              layout: [
                {
                  type: "conditional",
                  condition: "tett",
                  1: {
                    type: "legendFeature",
                    legendValue: "legendValues",
                    legendPrefix: "blaagronn-",
                    labelSuffix: "Tett by",
                    triggerText: "Mer info",
                    unique: true,
                    hover: true,
                  },
                  0: {
                    type: "legendFeature",
                    legendValue: "legendValues",
                    legendPrefix: "blaagronn-",
                    labelSuffix: "Åpen by",
                    triggerText: "Mer info",
                    unique: true,
                    hover: true,
                  },
                },
              ],
              values: {
                legendValues: ["TETT"],
                labelValues: [""],
                beskrivelse: "TETT",
                tett: "TETT",
                comparator: "TETT",
              },
              showExtendedInfo: true,
              extendedInfo: {
                header: "Blågrønn faktor",
                layout: [
                  {
                    type: "conditional",
                    condition: "TETT",
                    1: { type: "header", value: "Tett by" },
                    0: { type: "header", value: "Åpen by" },
                  },
                  {
                    type: "conditional",
                    condition: "TETT",
                    1: {
                      type: "paragraph",
                      value:
                        "I tett by har vi fastsatt total blågrønn faktor til minimum 0,7.",
                    },
                    0: {
                      type: "paragraph",
                      value:
                        "I åpen by har vi fastsatt total blågrønn faktor til minimum 0,8.",
                    },
                  },
                  {
                    type: "conditional",
                    condition: "TETT",
                    1: {
                      type: "paragraph",
                      value: "Tett by sammenfaller stort sett med indre by.",
                    },
                    0: {
                      type: "paragraph",
                      value: "Åpen by sammenfaller stort sett med ytre by.",
                    },
                  },
                  {
                    type: "header",
                    value: "Hvordan regner du ut blågrønn faktor?",
                  },
                  {
                    type: "paragraph",
                    value:
                      "Faktoren i normen er et forholdstall som skal tilfredsstilles der det bygges nye boliger.",
                  },
                  {
                    type: "paragraph",
                    value:
                      "Forholdstallet er 0,7 i tett by og 0,8 i åpen by og benevnes også Total blågrønn faktor for tomten.",
                  },
                  {
                    type: "paragraph",
                    value:
                      "Du må bruke regnearket vårt (se under) for å få ut forholdstallet. Tallet som regnes ut, viser forholdet mellom tomtestørrelsen og omfanget av blågrønne tiltak på eiendommen.",
                  },
                  {
                    type: "paragraph",
                    value:
                      "Det er til sammen tolv ulike blågrønne tiltak som belønnes i beregningen av faktoren.",
                  },
                  {
                    type: "paragraph",
                    value:
                      "De tolv tiltakene er delt i tre grupper: tiltak på terreng og tak, bevaring og beplantning av trær og vegetasjon, og tiltak som styrker den eksisterende blågrønne strukturen på nabotomtene.",
                  },
                  {
                    type: "header",
                    value:
                      "Her kan du lese mer om norm for blågrønn faktor i Oslo, og gjøre beregninger",
                  },
                  {
                    type: "link",
                    url: "https://www.oslo.kommune.no/getfile.php/13334986-1565345584/Tjenester og tilbud/Plan%2C bygg og eiendom/Byggesaksveiledere%2C normer og skjemaer/Bl%C3%A5gr%C3%B8nn faktor - Forslag til norm for bl%C3%A5gr%C3%B8nn faktor i boligprosjekter i Oslo.pdf",
                    text: "•	Norm for blågrønn faktor for boligprosjekter i Oslo (PDF 2,5MB)",
                  },
                  {
                    type: "link",
                    url: "https://www.oslo.kommune.no/getfile.php/13334992-1565345836/Tjenester og tilbud/Plan%2C bygg og eiendom/Byggesaksveiledere%2C normer og skjemaer/Bl%C3%A5gr%C3%B8nn faktor - Regneark for bl%C3%A5gr%C3%B8nn faktor.xlsx",
                    text: "•	Regneark (XLSX 148KB)",
                  },
                  {
                    type: "link",
                    url: "https://www.oslo.kommune.no/getfile.php/13334983-1565345465/Tjenester og tilbud/Plan%2C bygg og eiendom/Byggesaksveiledere%2C normer og skjemaer/Bl%C3%A5gr%C3%B8nn faktor - Brukerveiledning for bl%C3%A5gr%C3%B8nn faktor.pdf",
                    text: "•	Brukerveiledning (PDF 4MB)",
                  },
                  {
                    type: "link",
                    url: "https://www.oslo.kommune.no/getfile.php/13334993-1581085329/Tjenester%20og%20tilbud/Plan%2C%20bygg%20og%20eiendom/Byggesaksveiledere%2C%20normer%20og%20skjemaer/Bl%C3%A5gr%C3%B8nn%20faktor%20-%20Veiledning%20for%20tiltak%20i%20bl%C3%A5gr%C3%B8nn%20faktor.pdf",
                    text: "•	Veiledning for tiltak i blågrønn faktor",
                  },
                ],
              },
            },
          ],
        },
        {
          loaderType: "WFS",
          service: parameters.tableWfs + "kart.friluftsliv",
          table: "kart.friluftsliv",
          typeNames: ["eiendom_polygon"], //Brukes til WFS URL
          filterItem: ["teigid"],
          targets: [
            {
              id: "friluftsliv",
              layerCheckbox: true,
              layerId: "friluft",
              counter: "beskrivelse",
              comparator: "comparator",
              layout: [
                {
                  type: "legendFeature",
                  legendValue: "legendValues",
                  legendPrefix: "friluft-",
                  labelValue: "{0}",
                  unique: true,
                  hover: true,
                },
                { type: "link", url: "url", text: "navn", addCondition: "url" },
              ],
              values: {
                legendValues: ["OMRVERDI"],
                labelValues: ["LABEL"],
                beskrivelse: "OMRAADENAVN",
                comparator: "LABEL",
                url: "FAKTAARK",
                navn: "OMRAADENAVN",
              },
              showExtendedInfo: false,
            },
          ],
        },
        {
          //OVERVANN
          loaderType: "NOLOAD",
          service: parameters.tableWfs + "kart.avrenning",
          table: "kart.overvann",
          typeNames: ["eiendom_polygon"], //Brukes til WFS URL
          filterItem: ["teigid"],
          features: [
            {
              get: function (id) {
                return this[id];
              },
            },
          ],
          targets: [
            {
              id: "overvann",
              layerCheckbox: true,
              layerId: "overvann",
              comparator: "comparator",
              counter: "feature",
              layout: [
                {
                  type: "paragraph",
                  value:
                    "Overvann må håndteres overalt. Se temakart for overvann i venstremenyen.",
                },
              ],
              values: {},
              showExtendedInfo: false,
            },
          ],
        },
      ],
      dyplenker: [
        // url må inneholde @(gnr) og @(bnr) som byttes ut med gnr og bnr for eiendommen det klikkes på
        {
          innerHTML: "Bestill reguleringskart for byggesak",
          url: "https://www.byggesak.com/basket.aspx?BasketMode=OpenProductWizard&Basket[0][ProductNumber]=8643&Basket[0][Quantity]=1&Basket[0][DataFormatId]=37&Basket[0][PurposeId]=3&Referrer=Planinnsyn&Basket[0][Reference]=&Basket[0][Address.Gnr]=@(gnr)&Basket[0][Address.Bnr]=@(bnr)&Basket[0][Address.StreetName]=&Basket[0][Address.HouseNumber]=&Basket[0][Address.HouseLetter]=",
        },
        {
          innerHTML: "Bestill digitale kartdata",
          url: "https://www.byggesak.com/basket.aspx?BasketMode=OpenProductWizard&Basket[0][ProductNumber]=8502&Referrer=Planinnsyn&Basket[0][Reference]=&Basket[0][Address.Gnr]=@(gnr)&Basket[0][Address.Bnr]=@(bnr)&Basket[0][Address.StreetName]=&Basket[0][Address.HouseNumber]=&Basket[0][Address.HouseLetter]=&Basket[0][Geometry]=@(polygon)",
        },
        {
          innerHTML: "Bestill meglerpakke",
          url: "https://www.byggesak.com/basket.aspx?BasketMode=OpenProductWizard&Basket[0][ProductNumber]=8002&Basket[0][Quantity]=1&Basket[0][DataFormatId]=37&Basket[0][PurposeId]=3&Referrer=Planinnsyn&Basket[0][Reference]=&Basket[0][Address.Gnr]=@(gnr)&Basket[0][Address.Bnr]=@(bnr)&Basket[0][Address.StreetName]=&Basket[0][Address.HouseNumber]=&Basket[0][Address.HouseLetter]=",
        },
        {
          innerHTML: "Skal du bygge, rive eller endre?",
          url: "https://www.oslo.kommune.no/plan-bygg-og-eiendom/skal-du-bygge-rive-eller-endre/",
        },
        {
          innerHTML: "Se grunnforhold i Oslo",
          url: "https://od2.pbe.oslo.kommune.no/xkart/grunnforhold",
        },
      ],
      featureClickLayout: {
        vpor: {
          header: "VPOR",
          layout: [
            { type: "header", value: "T" },
            { type: "paragraph", value: "B" },
            { type: "header", value: "T1" },
            { type: "link", href: "LDOK", text: "LENKETEKST" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "LSAK",
              text: "Vis saksdokumenter",
            },
          ],
        },
        vporpaagaaende: {
          header: "VPOR",
          layout: [
            { type: "header", value: "T" },
            { type: "paragraph", value: "B" },
            { type: "link", href: "LDOK", text: "LENKETEKST" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "LSAK",
              text: "Vis saksdokumenter",
            },
          ],
        },
        tor: {
          header: "TOR",
          layout: [
            { type: "header", value: "T" },
            { type: "paragraph", value: "B" },
            { type: "header", value: "T1" },
            { type: "link", href: "LDOK", text: "LENKETEKST" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "LSAK",
              text: "Vis saksdokumenter",
            },
          ],
        },
        hovinbyenF: {
          header: "Strategisk plan for Hovinbyen",
          layout: [
            { type: "header", value: "T" },
            { type: "paragraph", value: "B" },
            { type: "link", href: "LDOK", text: "LENKETEKST" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "LSAK",
              text: "Vis saksdokumenter",
            },
          ],
        },
        hovinbyen_a: {
          header: "Strategisk plan for Hovinbyen",
          layout: [
            { type: "header", value: "NAVN" },
            { type: "paragraph", value: "TEKST" },
            {
              type: "link",
              url: "https://od2.pbe.oslo.kommune.no/pages/vedlegg/Aksene Hovinbyen - samlet.pdf#page=",
              urlParam: "PAGE",
              text: "LENKETEKST",
            },
            {
              type: "link",
              url: "https://innsyn.pbe.oslo.kommune.no/saksinnsyn/showfile.asp?jno=2020010672&fileid=9127592",
              text: "«Strategisk plan for Hovinbyen»",
            },
          ],
        },
        MFT: {
          header: "Midlertidig forbud mot tiltak",
          layout: [
            { type: "header", value: "T" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "S",
              text: "Vis i Saksinnsyn",
            },
          ],
        },
        detaljregulering: {
          header: "Pågående plansak",
          layout: [
            {
              type: "paragraph",
              prefix: "<strong>Saksnr</strong><br />",
              value: "S",
            },
            {
              type: "paragraph",
              prefix: "<strong>Saken gjelder</strong><br />",
              value: "T",
            },
            {
              type: "paragraph",
              prefix: "<strong>Sakstype</strong><br />",
              value: "PLANTYPESTR",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtaksdato</strong><br />",
              value: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtatt/behandlet av</strong><br />",
              value: "INSTANS",
            },
            {
              type: "paragraph",
              prefix: "<strong>Lovverk</strong><br />",
              value: "LOVREF",
            },
            {
              type: "paragraph",
              prefix: "<strong>Høydereferanse</strong><br />",
              value: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vertikalnivå</strong><br />",
              value: "VERTNIV",
            },
            {
              type: "paragraph",
              prefix: "<strong>Merknader</strong><br />",
              value: "MERKNAD",
              alt: "-",
            },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "S",
              text: "Se plansak",
            },
            {
              type: "link",
              condition: "STORYURL",
              type: "link",
              text: "Se plansaken i 3D",
              href: "STORYURL",
            },
            {
              type: "link",
              condition: "STED_URL",
              type: "link",
              text: "Se stedsanalyse",
              href: "STED_URL",
            },
          ],
        },
        smahusplanen: {
          header: "Pågående plansak",
          layout: [
            {
              type: "paragraph",
              prefix: "<strong>Saksnr</strong><br />",
              value: "S",
            },
            {
              type: "paragraph",
              prefix: "<strong>Saken gjelder</strong><br />",
              value: "T",
            },
            {
              type: "paragraph",
              prefix: "<strong>Sakstype</strong><br />",
              value: "PLANTYPESTR",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtaksdato</strong><br />",
              value: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtatt/behandlet av</strong><br />",
              value: "INSTANS",
            },
            {
              type: "paragraph",
              prefix: "<strong>Lovverk</strong><br />",
              value: "LOVREF",
            },
            {
              type: "paragraph",
              prefix: "<strong>Høydereferanse</strong><br />",
              value: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vertikalnivå</strong><br />",
              value: "VERTNIV",
            },
            {
              type: "paragraph",
              prefix: "<strong>Merknader</strong><br />",
              value: "MERKNAD",
              alt: "-",
            },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "S",
              text: "Se plansak",
            },
            {
              type: "link",
              condition: "STORYURL",
              type: "link",
              text: "Se plansaken i 3D",
              href: "STORYURL",
            },
            {
              type: "link",
              condition: "STED_URL",
              type: "link",
              text: "Se stedsanalyse",
              href: "STED_URL",
            },
          ],
        },
        omraaderegulering: {
          header: "Pågående plansak",
          layout: [
            {
              type: "paragraph",
              prefix: "<strong>Saksnr</strong><br />",
              value: "S",
            },
            {
              type: "paragraph",
              prefix: "<strong>Saken gjelder</strong><br />",
              value: "T",
            },
            {
              type: "paragraph",
              prefix: "<strong>Sakstype</strong><br />",
              value: "PLANTYPESTR",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtaksdato</strong><br />",
              value: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtatt/behandlet av</strong><br />",
              value: "INSTANS",
            },
            {
              type: "paragraph",
              prefix: "<strong>Lovverk</strong><br />",
              value: "LOVREF",
            },
            {
              type: "paragraph",
              prefix: "<strong>Høydereferanse</strong><br />",
              value: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vertikalnivå</strong><br />",
              value: "VERTNIV",
            },
            {
              type: "paragraph",
              prefix: "<strong>Merknader</strong><br />",
              value: "MERKNAD",
              alt: "-",
            },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "S",
              text: "Se plansak",
            },
            {
              type: "link",
              condition: "STORYURL",
              type: "link",
              text: "Se plansaken i 3D",
              href: "STORYURL",
            },
            {
              type: "link",
              condition: "STED_URL",
              type: "link",
              text: "Se stedsanalyse",
              href: "STED_URL",
            },
          ],
        },
        omreg: {
          header: "navn",
          external: true,
          url: parameters.planmetaWSUrl + "plannavn=",
          urlKey: "PLANNAVN",
          layout: [
            {
              type: "paragraph",
              prefix: "<strong>Saken gjelder</strong><br />",
              value: "tittel",
            },
            {
              type: "paragraph",
              prefix: "<strong>Sakstype</strong><br />",
              value: "typedef",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtaksdato</strong><br />",
              value: "vedtaksdato",
              alt: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtatt/behandlet av</strong><br />",
              value: "instans",
            },
            {
              type: "paragraph",
              prefix: "<strong>Lovverk</strong><br />",
              value: "lovref",
            },
            {
              type: "paragraph",
              prefix: "<strong>Høydereferanse</strong><br />",
              value: "href",
              alt: "-",
            },
            {
              type: "conditional",
              condition: "vertniv",
              1: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "Under bakken",
              },
              2: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "På bakkenivå",
              },
              3: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "Over bakken",
              },
              4: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "På havbunnen",
              },
              5: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "I vannsøylen",
              },
            },
            {
              type: "paragraph",
              prefix: "<strong>Merknader</strong><br />",
              value: "merknad",
              alt: "-",
            },
            {
              type: "conditional",
              condition: "type",
              30: {
                type: "link",
                url: parameters.regbestIntranett + "%PARAM%/%PARAM%",
                urlParam: ["vedtaksaar", "navn"],
                postfix: ".pdf",
                text: "Reguleringsbestemmelser",
              },
              21: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "navn",
                text: "Plandokument",
              },
              0: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "navn",
                text: "Se plansak",
              },
              "": {
                type: "link",
                url: parameters.regbestIntranett + "%PARAM%/%PARAM%",
                urlParam: ["vedtaksaar", "navn"],
                postfix: ".pdf",
                text: "Reguleringsbestemmelser",
              },
            },
            {
              type: "conditional",
              condition: "dok",
              0: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "saksnr",
                text: "Vis plansak",
              },
              1: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "saksnr",
                postfix: "&rplan=1",
                text: "Vis saksdokumenter",
              },
              "": {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "saksnr",
                postfix: "&rplan=1",
                text: "Vis saksdokumenter",
              },
            },
            {
              type: "multi",
              value: "koblinger",
              header: {
                type: "paragraph",
                value: "<strong>Knytninger til andre planer</strong><br />",
              },
              layout: {
                type: "div",
                children: [
                  { type: "span", value: "type", postfix: ":" },
                  {
                    type: "button",
                    value: "navn",
                    classname: "btn btn-link",
                    clickfunction: function (
                      plannavn,
                      target,
                      privateFns,
                      config,
                    ) {
                      var url =
                        parameters.planmetaWSUrl + "plannavn=" + plannavn;
                      $.ajax({
                        url: url,
                        success: function (response) {
                          let contents = target.children().detach();
                          target.append(
                            privateFns.createExtendedInfoSection(
                              config,
                              config,
                              response,
                              contents,
                              target,
                            ),
                          );
                        },
                        fail: function () {
                          console.error("fail");
                        },
                        error: function () {
                          console.error("error");
                        },
                      });
                    },
                  },
                ],
              },
            },
            {
              type: "link",
              condition: "STORYURL",
              type: "link",
              text: "Se plansaken i 3D",
              href: "STORYURL",
            },
            {
              type: "link",
              condition: "STED_URL",
              type: "link",
              text: "Se stedsanalyse",
              href: "STED_URL",
            },
          ],
        },
        planprogram: {
          header: "Planprogram",
          layout: [
            { type: "header", value: "T" },
            { type: "paragraph", value: "B" },
            { type: "header", value: "T1" },
            { type: "link", href: "LDOK", text: "LENKETEKST" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "LSAK",
              text: "Vis saksdokumenter",
            },
          ],
        },
        planprogrampaagaaende: {
          header: "Planprogram",
          layout: [
            { type: "header", value: "T" },
            { type: "paragraph", value: "B" },
            { type: "link", href: "LDOK", text: "LENKETEKST" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "LSAK",
              text: "Vis saksdokumenter",
            },
          ],
        },
        kunngjoringer: {
          header: "Plankunngjøring",
          layout: [
            { type: "paragraph", value: "T" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B1",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B2" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B3",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B4" },
            {
              type: "link",
              url: parameters.sidinmeningUrl + "?idnr=",
              urlParam: "ID",
              text: "Vis kunngjøringen og si din mening",
            },
          ],
        },
        byggesak: {
          cssClass: "feature-info-element element-box",
          layout: [
            { type: "paragraph", value: "T" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B1",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B2" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B3",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B4" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "B2",
              text: "Vis i Saksinnsyn",
            },
          ],
        },
        eiendomssak: {
          cssClass: "feature-info-element element-box",
          layout: [
            { type: "paragraph", value: "T" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B1",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B2" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B3",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B4" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "B2",
              text: "Vis i Saksinnsyn",
            },
          ],
        },
        postliste: {
          cssClass: "feature-info-element element-box",
          layout: [
            { type: "paragraph", value: "T" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B1",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B2" },
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "B3",
              suffix: "</strong><br/>",
            },
            { type: "paragraph", value: "B4" },
            {
              type: "link",
              url: parameters.saksinnsynCasedetUrl + "?caseno=",
              urlParam: "B2",
              text: "Vis i Saksinnsyn",
            },
          ],
        },
        trafikkmengde: {
          header: "Trafikkmengde",
          layout: [
            {
              type: "paragraph",
              prefix: "<strong>Gjelder for år: </strong>",
              value: "AAR_GJELDER_FOR",
            },
            {
              type: "paragraph",
              prefix: "<strong>Årsdøgntrafikk (ÅDT):</strong>",
              value: "AADT_TOTAL",
              suffix: "</strong><br/>",
            },
            {
              type: "paragraph",
              value:
                "ÅDT er gjennomsnittlig døgntrafikk i løpet av et år og er mål for trafikkmengden. ÅDT beregnes som antall kjøretøy som passerer et snitt på en vei (for begge retninger sammenlagt) i løpet av et år, dividert med 365.",
            },
            {
              type: "paragraph",
              value:
                "Dataene er hentet fra Norsk vegdatabank (NVDB) som driftes av Statens vegvesen og har informasjon om trafikkmengde på statlige og kommunale veier og gater. NVDB er normalt en pålitelig kilde for trafikkmengde på riksveinettet, men trafikkmengden på det kommunale veinettet oppdateres bare uregelmessig.",
            },
          ],
        },
        regPlan: {
          header: "navn",
          modify: function (plan) {
            if (plan.dok && plan.dok > 1) {
              plan.dok = 1;
            }
            return plan;
          },
          layout: [
            //{type: "paragraph", prefix: "<strong>Saksnr</strong><br />", value: "S"},
            {
              type: "paragraph",
              prefix: "<strong>Saken gjelder</strong><br />",
              value: "tittel",
            },
            {
              type: "paragraph",
              prefix: "<strong>Sakstype</strong><br />",
              value: "typedef",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtaksdato</strong><br />",
              value: "vedtaksdato",
              alt: "-",
            },
            {
              type: "paragraph",
              prefix: "<strong>Vedtatt/behandlet av</strong><br />",
              value: "instans",
            },
            {
              type: "paragraph",
              prefix: "<strong>Lovverk</strong><br />",
              value: "lovref",
            },
            {
              type: "paragraph",
              prefix: "<strong>Høydereferanse</strong><br />",
              value: "href",
              alt: "-",
            },
            {
              type: "conditional",
              condition: "vertniv",
              1: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "Under bakken",
              },
              2: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "På bakkenivå",
              },
              3: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "Over bakken",
              },
              4: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "På havbunnen",
              },
              5: {
                type: "paragraph",
                prefix: "<strong>Vertikalnivå</strong><br />",
                value: "I vannsøylen",
              },
              "2,3,1": {
                type: "paragraph",
                value: "På bakkenivå, Over bakken, I Vannsøylen",
              },
            },
            {
              type: "paragraph",
              prefix: "<strong>Merknader</strong><br />",
              value: "merknad",
              alt: "-",
            },
            {
              type: "conditional",
              condition: "type",
              "": {
                type: "link",
                url: parameters.saksinnsynShowregbestUrl + "planid=",
                urlParam: "id",
                text: "Reguleringsbestemmelser",
                addCondition: "vedtaksdato",
              },
              0: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "navn",
                text: "Se plansak",
              },
              21: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "navn",
                text: "Plandokument",
              },
              30: {
                type: "link",
                url: parameters.saksinnsynShowregbestUrl + "planid=",
                urlParam: "id",
                text: "Reguleringsbestemmelser",
                addCondition: "vedtaksdato",
              },
              35: {
                type: "link",
                url: parameters.saksinnsynShowregbestUrl + "planid=",
                urlParam: "id",
                text: "Reguleringsbestemmelser",
                addCondition: "vedtaksdato",
              },
            },
            {
              type: "conditional",
              condition: "dok",
              0: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "saksnr",
                text: "Vis plansak",
              },
              1: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "saksnr",
                postfix: "&rplan=1",
                text: "Vis saksdokumenter",
              },
              "": {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "saksnr",
                postfix: "&rplan=1",
                text: "Vis saksdokumenter",
              },
              //Endret urlParam til navn pga MFT.
              undefined: {
                type: "link",
                url: parameters.saksinnsynCasedetUrl + "?caseno=",
                urlParam: "navn",
                postfix: "&rplan=1",
                text: "Vis saksdokumenter",
              },
            },
            {
              type: "multi",
              value: "koblinger",
              header: {
                type: "paragraph",
                value: "<strong>Knytninger til andre planer</strong><br />",
              },
              layout: {
                type: "div",
                children: [
                  { type: "span", value: "type", postfix: ":" },
                  {
                    type: "button",
                    value: "navn",
                    classname: "btn btn-link",
                    clickfunction: function (
                      plannavn,
                      target,
                      privateFns,
                      config,
                    ) {
                      var url =
                        parameters.planmetaWSUrl + "plannavn=" + plannavn;
                      $.ajax({
                        url: url,
                        success: function (response) {
                          let contents = target.children().detach();
                          target.append(
                            privateFns.createExtendedInfoSection(
                              config,
                              config,
                              response,
                              contents,
                              target,
                            ),
                          );
                        },
                        fail: function () {
                          console.error("fail");
                        },
                        error: function () {
                          console.error("error");
                        },
                      });
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    },
    activeTip: false,
     tipText:
      "Planinnsyn vil være delvis utilgjengelig onsdag 30. sept kl. 16-20",
    tipId: "utilgjengelig30092026",
  }));

// Legg til ekstra css-filer
//$("head").append("<link rel='stylesheet' type='text/css' href='css/foo.css'>");

//Titlelink setter lenke for oslologo + planinnsyn. Går til seg selv hvis den ikke er satt.
export default {
  intranett: false,
  baseLayers: configs.baseLayers,
  layermenuLayers: configs.layermenuLayers,
  fkbLayers: configs.fkbLayers,
  mapInteractions: configs.mapInteractions,
  mapTools: configs.mapTools,
  site: {
    title: "|&nbsp;&nbsp; Planinnsyn",
    titleLink: "",
  },
  loadplugins: function (map, callback) {
    attribution.initiate({
      parent: "footerId",
      id: "copy-pbe",
      text: "©Oslo PBE",
    });
    layermenu.initiate(configs.layermenuLayers, "Velg kartlag");
    baselayerSwitcher.initiate(
      document.getElementById("mapmenu"),
      map,
      "bakgrunn",
      "flyfoto",
      "./img/bakgrunnskart.min.png",
      "./img/flyfoto.min.jpg",
    );
    searchPlugin.initiate(configs.search);
    contextPlugin.initiate(configs);
    //globals.handleMapClick = contextPlugin.exposedHandleMapClick;
    topMenuPlugin.initiate(configs.topMenu, parameters.intranett);
    callback();
  },
  customClickTriggers: [],
  parameters: parameters,
  configs: configs,
  getConfigs: function () {
    return configs;
  },
};
